import "@fontsource/baloo-bhai-2/500.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/700.css";
import { defineStyle as Y, defineStyleConfig as O, createMultiStyleConfigHelpers as V, cssVar as Ae, extendTheme as a1, chakra as M, Box as w, HStack as de, IconButton as I, Breadcrumb as l1, BreadcrumbItem as ue, BreadcrumbLink as d1, Skeleton as s1, MenuItem as Ie, Flex as C, Tooltip as R, Text as f, Stack as v, Button as F, Divider as se, TableContainer as c1, Table as g1, Thead as m1, Tr as Ce, Th as p1, Menu as q, MenuButton as K, Portal as Re, MenuList as J, Tbody as u1, Td as C1, Input as ce, Editable as h1, EditablePreview as f1, EditableInput as b1, Container as he, Spacer as Z, AbsoluteCenter as y1, Spinner as x1, forwardRef as k1, Modal as He, ModalOverlay as ze, ModalContent as De, ModalHeader as Be, ModalCloseButton as Te, ModalBody as Pe, ModalFooter as Oe, Slider as w1, SliderTrack as S1, SliderFilledTrack as v1, SliderThumb as E1, AccordionItem as Ve, AccordionButton as Ze, AccordionIcon as L1, AccordionPanel as We, UnorderedList as _1, ListItem as F1, Accordion as X, Tag as M1, Avatar as $e, useDisclosure as A1, MenuGroup as I1, Image as R1, Alert as H1, AlertDescription as z1, useAccordionContext as D1, useColorMode as Q } from "@chakra-ui/react";
import { alertAnatomy as B1, drawerAnatomy as T1, editableAnatomy as P1, formAnatomy as O1, inputAnatomy as V1, menuAnatomy as Z1, modalAnatomy as W1, popoverAnatomy as $1, tabsAnatomy as j1 } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as N1 } from "@chakra-ui/system";
import { createMultiStyleConfigHelpers as je, defineStyle as ge } from "@chakra-ui/styled-system";
import { jsx as r, jsxs as m, Fragment as P } from "react/jsx-runtime";
import { Editor as U1 } from "@monaco-editor/react";
import { format as X1 } from "sql-formatter";
import { createColumnHelper as G1, useReactTable as Y1, getPaginationRowModel as q1, getCoreRowModel as K1, getSortedRowModel as J1, flexRender as te } from "@tanstack/react-table";
import * as d from "react";
import { useState as S, useEffect as H, useMemo as Q1, useRef as ee, Suspense as et, useCallback as tt } from "react";
import { ResizableBox as Ne } from "react-resizable";
import { parse as rt } from "papaparse";
import nt from "he";
import ot from "lodash.debounce";
import { keyframes as me } from "@emotion/react";
import { VegaLite as it } from "react-vega";
import { parseISO as at, isSameYear as lt, format as fe } from "date-fns";
const _ = {
  50: "#FFFFFF",
  100: "#F9F9F9",
  200: "#F5F5F5",
  300: "#EAEAEA",
  400: "#C5C5C7",
  500: "#797D83",
  600: "#5A5F67",
  700: "#444750",
  800: "#22252C",
  850: "#1A1C21",
  900: "#0A0D15",
  1e3: "#000000"
}, z = {
  50: "#EEF5FF",
  100: "#D2E4FF",
  200: "#A8CBFE",
  300: "#81B4FE",
  400: "#6CA9FF",
  500: "#5098FF",
  600: "#2B82FF",
  700: "#0E6EF6",
  800: "#0652C3",
  900: "#002862"
}, Ue = {
  25: "#F0F1FF",
  50: "#E0E3FF",
  100: "#BEC4FF",
  200: "#97A2FF",
  300: "#6A78F8",
  400: "#4E5FF3",
  500: "#3A4BE4",
  600: "#2A3CD7",
  700: "#202FB8",
  800: "#131F87",
  900: "#0A125A"
}, D = {
  25: "#FDF0FF",
  50: "#FCE1FF",
  100: "#F5CBF9",
  200: "#F6B4FC",
  300: "#F69AFF",
  400: "#EF81FA",
  500: "#E054EC",
  600: "#B636C1",
  700: "#951BA0",
  800: "#6F0C78",
  900: "#520659"
}, B = {
  50: "#FFE0E3",
  100: "#FFCCCC",
  200: "#FDA8A8",
  300: "#FF8B8B",
  400: "#FF6B6B",
  500: "#FF3232",
  600: "#DE1D1D",
  700: "#BA1313",
  800: "#8E0E0E",
  900: "#580707"
}, $ = {
  50: "#FFEEDA",
  100: "#FFE1BD",
  200: "#FFCE95",
  300: "#FFBF74",
  400: "#FFAA46",
  500: "#FF961B",
  600: "#EB8308",
  700: "#C76C00",
  800: "#9F5600",
  900: "#713D00"
}, Xe = {
  50: "#FFF7D9",
  100: "#FFEEB3",
  200: "#FFE792",
  300: "#FFDE67",
  400: "#FFD643",
  500: "#FFC909",
  600: "#E4B200",
  700: "#C69B00",
  800: "#9D7A00",
  900: "#644E00"
}, G = {
  50: "#CFFFDF",
  100: "#ACFBC7",
  200: "#86F3AB",
  300: "#61EA8F",
  400: "#2DD665",
  500: "#0AB744",
  600: "#029232",
  700: "#007126",
  800: "#00511B",
  900: "#003110"
}, Ge = {
  50: "#C9FFF3",
  100: "#9EFBE6",
  200: "#6DF4D5",
  300: "#3EECC4",
  400: "#16DFB0",
  500: "#12C69C",
  600: "#10A884",
  700: "#0C8367",
  800: "#096C55",
  900: "#024F3D"
}, j = {
  50: "#DAF7FE",
  100: "#ADEDFF",
  200: "#85E4FF",
  300: "#5CDCFF",
  400: "#30D2FF",
  500: "#00C0F5",
  600: "#03AAD7",
  700: "#0095BE",
  800: "#007A9B",
  900: "#005B73"
}, T = {
  50: "#EFE6FF",
  100: "#D8C2FF",
  200: "#BE99FF",
  300: "#A36DFF",
  400: "#8B47FF",
  500: "#7223F9",
  600: "#5A00F5",
  700: "#4600C0",
  800: "#310086",
  900: "#1E0050"
}, Ye = {
  50: "#FCF7EF",
  100: "#F4F2EC",
  200: "#E8CECE",
  300: "#E8CECE",
  400: "#E8CECE",
  500: "#E8CECE",
  600: "#E8CECE",
  700: "#E8CECE",
  800: "#E8CECE",
  900: "#E8CECE"
}, dt = {
  black: _[900],
  white: _[50],
  blue: z[500],
  sapphire: Ue[500],
  pink: D[500],
  red: B[500],
  orange: $[500],
  yellow: Xe[400],
  green: G[400],
  teal: Ge[300],
  cyan: j[300],
  purple: T[400],
  sand: Ye[100]
}, st = {
  sand: Ye,
  black: _,
  blue: z,
  sapphire: Ue,
  pink: D,
  red: B,
  orange: $,
  yellow: Xe,
  green: G,
  teal: Ge,
  cyan: j,
  purple: T,
  main: dt
}, { definePartsStyle: ct, defineMultiStyleConfig: gt } = N1(B1.keys), mt = ct({
  container: {
    paddingTop: "spacing-xs",
    paddingBottom: "spacing-xs"
  }
}), pt = gt({ baseStyle: mt }), ut = Y({
  paddingLeft: "1rem !important",
  paddingRight: "1rem !important",
  height: "3rem",
  textStyles: "label/M/medium !important"
}), Ct = Y({
  paddingLeft: "0.75rem !important",
  paddingRight: "0.75rem !important",
  height: "2.5rem",
  textStyles: "label/S/medium !important"
}), ht = Y({
  paddingLeft: "0.5rem !important",
  paddingRight: "0.5rem !important",
  height: "2rem",
  textStyles: "label/S/medium !important"
}), ft = O({
  sizes: { lg: ut, sm: ht, md: Ct },
  variants: {
    primary: {
      color: "text.selectable-primary",
      backgroundColor: "background.accent-primary.light",
      _hover: {
        backgroundColor: "background.accent-primary.medium"
      },
      _active: {
        backgroundColor: "background.accent-primary.dark"
      }
    },
    secondary: {
      color: "foreground.primary",
      backgroundColor: "background.primary",
      border: "2px solid",
      borderColor: "border.secondary !important",
      _hover: {
        backgroundColor: "background.secondary"
      },
      _active: {
        backgroundColor: "background.tertiary"
      },
      _disabled: {
        opacity: 1,
        color: "foreground.tertiary",
        borderColor: "border.secondary"
      }
    },
    outline: {
      color: "foreground.primary",
      backgroundColor: "background.primary",
      border: "2px solid",
      borderColor: "border.secondary !important",
      _hover: {
        backgroundColor: "background.secondary"
      },
      _active: {
        backgroundColor: "background.tertiary"
      },
      _disabled: {
        opacity: 1,
        color: "foreground.tertiary",
        borderColor: "border.secondary"
      }
    },
    ghost: {
      color: "foreground.primary",
      backgroundColor: "transparent",
      _hover: {
        backgroundColor: "background.secondary"
      },
      _active: {
        backgroundColor: "background.tertiary"
      },
      _disabled: {
        backgroundColor: "transparent",
        _hover: {
          backgroundColor: "transparent"
        }
      }
    },
    editor: {
      borderRadius: "radius-lg",
      color: "foreground.primary",
      border: "1px solid",
      borderColor: "border.primary !important",
      _hover: {
        bg: "background.secondary",
        color: "foreground.primary"
      },
      _active: {
        backgroundColor: "background.tertiary"
      },
      _disabled: {
        color: "foreground.tertiary !important"
      }
    },
    displayPrimary: {
      textStyle: "button",
      bg: "black.800",
      _hover: { bg: "black.700" },
      _active: { bg: "black.600" },
      color: "foreground.inverse",
      paddingLeft: "1.5rem !important",
      paddingTop: "1rem !important",
      paddingBottom: "1rem !important",
      paddingRight: "1.5rem !important",
      borderRadius: "radius-xl",
      lineHeight: "150%",
      minWidth: "none",
      height: "3.5rem"
    },
    displayOutline: {
      textStyle: "button",
      bg: "transparent",
      color: "foreground.primary",
      borderColor: "foreground.primary",
      border: "0.125rem solid",
      paddingLeft: "1.5rem !important",
      paddingTop: "1rem !important",
      paddingBottom: "1rem !important",
      paddingRight: "1.5rem !important",
      borderRadius: "radius-xl",
      lineHeight: "150%",
      minWidth: "none",
      height: "3.5rem",
      _hover: {
        bg: "rgba(10, 13, 21, 0.06)"
      },
      _dark: {
        border: "2px solid"
      }
    }
  },
  baseStyle: {
    borderRadius: "radius-sm",
    transition: "all 0.1s ease-in-out",
    fontStyle: "label/M/medium !important",
    fontFamily: "label",
    fontWeight: "500",
    color: "foreground.primary",
    backgroundColor: "background.primary",
    borderColor: "border.secondary",
    _disabled: {
      opacity: 1,
      color: "foreground.tertiary",
      backgroundColor: "background.secondary",
      _hover: {
        backgroundColor: "background.secondary !important"
      }
    },
    _loading: {
      opacity: 1,
      color: "foreground.tertiary",
      backgroundColor: "background.secondary",
      _hover: {
        backgroundColor: "background.secondary"
      }
    }
  },
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}), bt = O({
  baseStyle: {
    borderColor: "border.primary"
  }
}), { definePartsStyle: yt, defineMultiStyleConfig: xt } = je(T1.keys), kt = yt({
  header: {
    fontWeight: "medium",
    textStyle: "label/M/medium"
  },
  dialog: {
    bg: "background.primary"
  }
}), wt = xt({
  baseStyle: kt
}), { definePartsStyle: St, defineMultiStyleConfig: vt } = je(P1.keys), Et = ge({
  textStyle: "label/L/medium",
  borderRadius: "xxs",
  py: "0",
  lineHeight: "1.5rem",
  transitionProperty: "common",
  transitionDuration: "normal",
  _hover: {
    bg: "background.secondary"
  }
}), Lt = ge({
  textStyle: "label/L/medium",
  borderRadius: "xxs",
  py: "0",
  lineHeight: "1.5rem",
  transitionProperty: "common",
  transitionDuration: "normal",
  bg: "background.secondary",
  width: "auto",
  _focusVisible: { boxShadow: "none" },
  _placeholder: { color: "foreground.secondary" }
}), _t = ge({
  textStyle: "label/L/medium",
  borderRadius: "xxs",
  py: "0",
  transitionProperty: "common",
  transitionDuration: "normal",
  bg: "background.secondary",
  width: "auto",
  _focusVisible: { boxShadow: "none" },
  _placeholder: { color: "foreground.secondary" }
}), Ft = St({
  preview: Et,
  input: Lt,
  textarea: _t
}), Mt = vt({
  baseStyle: Ft
}), { definePartsStyle: At, defineMultiStyleConfig: It } = V(O1.keys), Rt = At({
  container: {
    legend: {
      mb: 0.5
    }
  }
}), Ht = It({ baseStyle: Rt }), zt = O({
  baseStyle: {
    color: "foreground.secondary",
    mb: "spacing-xs"
  }
}), { definePartsStyle: Dt, defineMultiStyleConfig: Bt } = V(V1.keys), Tt = Dt({
  // define the part you're going to style
  field: {
    paddingX: "spacing-sm",
    opacity: "1",
    borderRadius: "radius-sm",
    outline: "2px",
    border: "1px solid",
    background: "background.primary",
    color: "foreground.primary",
    borderColor: "border.secondary",
    _hover: {
      borderColor: "border.primary"
    },
    "::placeholder": {
      color: "text.placeholder"
    }
  }
}), Pt = Bt({ baseStyle: Tt }), { definePartsStyle: Ot, defineMultiStyleConfig: Vt } = V(Z1.keys), Zt = Ot({
  groupTitle: {
    marginLeft: "spacing-sm",
    marginBottom: "spacing-xs",
    marginTop: "0",
    textStyle: "label/S/regular",
    fontWeight: "regular !important",
    color: "foreground.secondary"
  },
  item: {
    bg: "background.primary",
    color: "foreground.primary",
    textStyle: "label/M/regular",
    paddingX: "0.5rem",
    height: "2.25rem",
    _hover: {
      bg: "background.secondary"
    },
    _focus: {
      bg: "background.secondary"
    },
    _active: {
      bg: "background.tertiary"
    }
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: "spacing-xxs",
    borderRadius: "radius-sm",
    paddingY: "spacing-xs",
    bg: "background.primary",
    border: "1px solid",
    borderColor: "border.primary",
    zIndex: 10,
    textStyle: "label/M/regular"
  }
}), Wt = Vt({ baseStyle: Zt }), { definePartsStyle: qe, defineMultiStyleConfig: $t } = V(W1.keys), jt = qe({
  header: {
    textStyle: "label/L/medium",
    fontWeight: "500",
    padding: "0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  body: {
    textStyle: "body/M/regular",
    padding: "0"
  },
  footer: {
    padding: "0",
    display: "flex",
    justifyContent: "flex-end"
  },
  dialog: {
    borderRadius: "radius-md",
    overflow: "hidden",
    bg: "background.primary",
    paddingY: "2",
    paddingX: "3",
    gap: "3"
  },
  overlay: {
    bg: "overlay"
  }
}), Nt = qe({
  header: {
    textStyle: "heading/2",
    lineHeight: "2rem",
    fontWeight: "500",
    paddingLeft: "spacing-xl",
    paddingRight: "spacing-xl",
    padding: "spacing-md",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid",
    borderColor: "border.secondary"
  },
  body: {
    textStyle: "body/M/regular",
    paddingLeft: "spacing-xl",
    paddingRight: "spacing-xl",
    padding: "spacing-xs"
  },
  footer: {
    paddingLeft: "spacing-xl",
    paddingRight: "spacing-xl",
    padding: "spacing-s",
    display: "flex",
    justifyContent: "flex-end"
  },
  dialog: {
    borderRadius: "radius-md",
    overflow: "hidden",
    padding: "0",
    bg: "background.primary"
  },
  overlay: {
    bg: "overlay"
  }
}), Ut = $t({ baseStyle: jt, variants: { large: Nt } }), { definePartsStyle: Xt, defineMultiStyleConfig: Gt } = V($1.keys), Yt = Xt({
  popper: {
    _focus: {
      boxShadow: "none !important"
    }
  },
  closeButton: {
    textStyle: "label/M/medium",
    color: "foreground.primary"
  },
  arrow: {
    bg: "background-primary !important",
    borderColor: "button-secondary-stroke"
  },
  content: {
    gap: "8px",
    paddingY: "1",
    borderRadius: "12px",
    bg: "background.primary",
    borderColor: "border.primary",
    _focus: {
      boxShadow: "none !important"
    }
  },
  header: {
    borderBottom: "none",
    textStyle: "label/M/medium",
    bg: "background.primary"
  },
  body: {
    textStyle: "primary"
  },
  footer: {}
}), qt = Gt({
  baseStyle: Yt,
  variants: {
    responsive: {
      content: { width: "unset" }
    }
  }
}), be = Ae("skeleton-start-color"), ye = Ae("skeleton-end-color"), Kt = Y({
  _light: {
    [be.variable]: "colors.black.100",
    [ye.variable]: "colors.black.300"
  },
  _dark: {
    [be.variable]: "colors.black.800",
    [ye.variable]: "colors.black.600"
  }
}), Jt = O({
  variants: { base: Kt },
  defaultProps: {
    variant: "base"
  }
}), { definePartsStyle: Qt, defineMultiStyleConfig: er } = V(j1.keys), tr = Qt({
  tab: {
    borderBottom: "none",
    margin: 0,
    padding: "spacing-xs !important",
    color: "foreground.secondary !important",
    borderRadius: "radius-sm",
    background: "background.primary",
    textStyle: "label/M/medium",
    border: 0,
    _hover: {
      color: "foreground.primary !important",
      bg: "background.secondary"
    },
    _selected: {
      border: "0",
      color: "foreground.primary !important",
      bg: "background.secondary"
    },
    _active: {
      border: "0",
      color: "foreground.primary !important",
      bg: "background.secondary"
    },
    _focus: {
      border: "0",
      color: "foreground.primary !important",
      bg: "background.secondary"
    }
  },
  tablist: {
    borderBottom: "none !important",
    gap: "spacing-xs"
  },
  tabpanel: {
    padding: 0,
    borderBottom: "none !important"
  },
  tabpanels: {
    borderBottom: "none"
  }
}), rr = {
  sidebar: tr
}, nr = er({ variants: rr }), or = O({
  baseStyle: {
    paddingX: "spacing-sm",
    paddingY: "spacing-xs",
    opacity: "1",
    outline: "2px",
    color: "foreground.primary",
    border: "1px solid",
    borderColor: "border.primary",
    "::placeholder": {
      color: "foreground.tertiary"
    }
  }
}), ir = O({
  baseStyle: {
    bg: "foreground.primary",
    "&[data-popper-placement^='top'] > #tooltip-arrow, &[data-popper-placement^='bottom'] > #tooltip-arrow, &[data-popper-placement^='right'] > #tooltip-arrow, &[data-popper-placement^='left'] > #tooltip-arrow": {
      bg: "foreground.primary"
    }
  }
}), ar = {
  global: () => ({
    ":root": {
      "--focus-border": "#007fd4",
      "--separator-border": "transparent"
    },
    "::selection": {
      background: "background.highlight"
    },
    html: {
      height: "100%",
      overflow: "hidden"
    },
    body: {
      height: "100%",
      fontFamily: "body",
      fontWeight: "400",
      fontSize: { base: "md", "3xl": "lg", "4xl": "xl" },
      background: "background.primary",
      borderColor: "border.primary",
      color: "foreground.primary"
    },
    "#root": {
      height: "100%"
    },
    ".sash": {
      zIndex: "docked"
    },
    ".chakra-button__icon": {
      marginInlineEnd: "spacing-xs"
    }
  })
}, lr = {
  modal: {
    paddingX: "0.5rem",
    paddingY: "0.75rem",
    borderRadius: "8px",
    bg: "background.primary",
    border: "1px solid",
    borderColor: "border.primary",
    boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.10)"
  }
}, dr = {
  brand: "'Baloo Bhai 2', sans-serif",
  heading: "Poppins, serif",
  label: "Poppins, serif",
  body: "Inter, serif"
}, sr = {
  xs: "0.625rem",
  // 10px
  sm: "0.75rem",
  // 12px
  md: "0.875rem",
  // 14px
  lg: "1rem",
  // 16px
  xl: "1.125rem",
  // 18px
  "2xl": "1.25rem",
  // 20px
  "3xl": "1.5rem",
  // 24px
  "3.5xl": "1.75rem",
  // 28px
  "4xl": "2.25rem",
  // 36px
  "5xl": "3rem",
  // 48px
  "6xl": "4.375rem",
  // 70px
  "7xl": "5.25rem",
  // 84px
  "icon-xs": "0.875rem",
  "icon-sm": "1rem",
  "icon-md": "1.25rem",
  "icon-lg": "1.25rem"
}, cr = {
  brand: {
    fontFamily: "brand",
    fontSize: "4xl",
    fontWeight: "500",
    color: "foreground.primary"
  },
  "heading/display/L": {
    fontFamily: "heading",
    fontWeight: "600",
    fontSize: ["5xl", "6xl"],
    lineHeight: "120%",
    color: "foreground.primary"
  },
  "heading/display/S": {
    fontFamily: "heading",
    fontWeight: "600",
    fontSize: ["4xl", "5xl"],
    lineHeight: "120%",
    color: "foreground.primary"
  },
  "heading/display/XS": {
    fontFamily: "heading",
    fontWeight: "600",
    fontSize: ["3xl", "4xl"],
    lineHeight: "120%",
    color: "foreground.primary"
  },
  "heading/large": {
    fontFamily: "heading",
    fontSize: "5xl",
    fontWeight: "700",
    lineHeight: "100%",
    color: "foreground.primary"
  },
  // TODO: change heading/1 and heading/2 and add heading/3
  "heading/1": {
    fontFamily: "heading",
    fontSize: "3.5xl",
    fontWeight: "500",
    lineHeight: "100%",
    color: "foreground.primary"
  },
  "heading/2": {
    fontFamily: "heading",
    fontSize: "3xl",
    fontWeight: "500",
    lineHeight: "120%",
    color: "foreground.primary"
  },
  "heading/3": {
    fontFamily: "heading",
    fontSize: "2xl",
    fontWeight: "500",
    lineHeight: "120%",
    color: "foreground.primary"
  },
  "label/L/regular": {
    fontFamily: "label",
    fontSize: "lg",
    fontWeight: "400",
    lineHeight: "20px",
    color: "foreground.primary",
    letterSpacing: "0.16px"
  },
  "label/L/medium": {
    fontFamily: "label",
    fontSize: "lg",
    fontWeight: "500",
    lineHeight: "20px",
    color: "foreground.primary",
    letterSpacing: "0.16px"
  },
  "label/L/medium/underline": {
    textDecoration: "underline",
    fontFamily: "label",
    fontSize: "lg",
    fontWeight: "500",
    lineHeight: "20px",
    color: "foreground.primary",
    letterSpacing: "0.16px"
  },
  "label/M/regular": {
    fontFamily: "label",
    fontSize: "md",
    fontWeight: "400",
    lineHeight: "150%",
    color: "foreground.primary",
    letterSpacing: "0.14px"
  },
  "label/M/regular/underline": {
    fontFamily: "label",
    fontSize: "md",
    fontWeight: "400",
    lineHeight: "150%",
    textDecoration: "underline",
    color: "foreground.primary",
    letterSpacing: "0.14px"
  },
  "label/M/medium": {
    fontFamily: "label",
    fontSize: "md",
    fontWeight: "500",
    lineHeight: "150%",
    color: "foreground.primary",
    letterSpacing: "0.14px"
  },
  "label/S/regular": {
    fontFamily: "label",
    fontSize: "sm",
    fontWeight: "400",
    lineHeight: "150%",
    color: "foreground.primary",
    letterSpacing: "0.12px"
  },
  "label/S/medium": {
    fontFamily: "label",
    fontSize: "sm",
    fontWeight: "500",
    lineHeight: "150%",
    color: "foreground.primary",
    letterSpacing: "0.12px"
  },
  "label/S/italic": {
    fontFamily: "label",
    fontSize: "sm",
    fontWeight: "400",
    lineHeight: "150%",
    color: "foreground.primary",
    letterSpacing: "0.12px",
    fontStyle: "italic"
  },
  "label/XS": {
    fontFamily: "label",
    fontSize: "xs",
    fontWeight: "400",
    lineHeight: "150%",
    color: "foreground.primary",
    letterSpacing: "0.1px"
  },
  "paragraph/S/regular": {
    fontFamily: "body",
    fontSize: "sm",
    fontWeight: "400",
    lineHeight: "150%",
    color: "foreground.primary",
    letterSpacing: "0.12px"
  },
  "paragraph/M/regular": {
    fontFamily: "body",
    fontSize: "md",
    fontWeight: "400",
    lineHeight: "171%",
    color: "foreground.primary",
    letterSpacing: "0.14px"
  },
  "paragraph/M/medium": {
    fontFamily: "body",
    fontSize: "md",
    fontWeight: "500",
    lineHeight: "171%",
    color: "foreground.primary",
    letterSpacing: "0.14px"
  },
  "paragraph/L/regular": {
    fontFamily: "body",
    fontSize: "lg",
    fontWeight: "400",
    lineHeight: "150%",
    color: "foreground.primary",
    letterSpacing: "0.14px"
  },
  "paragraph/L/medium": {
    fontFamily: "body",
    fontSize: "lg",
    fontWeight: "500",
    lineHeight: "150%",
    color: "foreground.primary",
    letterSpacing: "0.14px"
  }
}, gr = {
  pending: {
    default: "purple.100",
    _dark: "purple.500"
  },
  default: {
    default: "sapphire.100",
    _dark: "sapphire.500"
  },
  "default-hover": {
    default: "sapphire.200",
    _dark: "sapphire.600"
  },
  "default-active": {
    default: "sapphire.300",
    _dark: "sapphire.700"
  }
}, x = {
  // 0px
  "space.50": "0.25rem",
  // 4px
  "space.100": "0.5rem",
  // 8px
  "space.150": "0.75rem",
  // 12px
  "space.200": "1rem",
  // 20px
  "space.300": "1.5rem",
  // 24px
  "space.400": "2rem",
  // 32px
  "space.500": "2.5rem",
  // 40px
  "space.600": "3rem",
  // 48px
  "space.800": "4rem",
  // 64px
  "space.1000": "5rem",
  // 80px
  "space.1200": "6rem",
  // 96px
  "space.2000": "10rem"
  // 160px
}, E = {
  0: "0",
  "0.25": "0.125rem",
  "0.5": "0.25rem",
  1: "0.5rem",
  "1.5": "0.75rem",
  2: "1rem",
  4: "2rem"
}, re = {
  "shadow.low": "0px 2px 4px 0px rgba(0, 0, 0, 0.10)",
  "shadow.mid": "0px 6px 12px 0px rgba(0, 0, 0, 0.10)",
  "shadow.high": "0px 12px 24px 0px rgba(0, 0, 0, 0.10)"
}, mr = {
  // Chakra overrides - do not use directly
  "0.5": x["space.50"],
  1: x["space.100"],
  "1.5": x["space.150"],
  2: x["space.200"],
  3: x["space.300"],
  4: x["space.400"],
  5: x["space.500"],
  6: x["space.600"],
  8: x["space.800"],
  10: x["space.1000"],
  12: x["space.1200"],
  20: x["space.2000"],
  // ---
  "spacing-none": "0",
  "spacing-xxs": x["space.50"],
  "spacing-xs": x["space.100"],
  "spacing-sm": x["space.150"],
  "spacing-md": x["space.200"],
  "spacing-lg": x["space.300"],
  "spacing-xl": x["space.400"],
  "spacing-xxl": x["space.500"]
}, pr = {
  // Chakra overrides - do not use directly
  0: E[0],
  "0.5": E["0.5"],
  1: E[1],
  "1.5": E["1.5"],
  2: E[2],
  // ---
  "radius-none": E[0],
  "radius-xxs": E["0.25"],
  "radius-xs": E["0.5"],
  "radius-sm": E[1],
  "radius-md": E["1.5"],
  "radius-lg": E[2],
  "radius-xl": E[4]
}, ur = {
  "shadow-low": re["shadow.low"],
  "shadow-mid": re["shadow.mid"],
  "shadow-high": re["shadow.high"]
}, Cr = {
  accents: {
    "blue-dark": {
      default: "blue.700",
      _dark: "blue.200"
    },
    "blue-light": {
      default: "blue.200",
      _dark: "blue.900"
    }
  },
  primary: {
    default: "black.400",
    _dark: "black.600"
  },
  secondary: {
    default: "black.300",
    _dark: "black.700"
  },
  tertiary: {
    default: "black.300",
    _dark: "main.white"
  },
  inverse: {
    default: "black.400",
    _dark: "black.600"
  }
}, hr = {
  primary: {
    default: "main.white",
    _dark: "black.900"
  },
  secondary: {
    default: "black.200",
    _dark: "black.800"
  },
  tertiary: {
    default: "black.300",
    _dark: "black.700"
  },
  inverse: {
    default: "black.800",
    _dark: "black.100"
  },
  dark: {
    default: "black.900",
    _dark: "black.900"
  },
  white: {
    default: "main.white",
    _dark: "main.white"
  },
  light: {
    default: "black.100",
    _dark: "black.850"
  },
  display: {
    "very-light": {
      default: "sand.50",
      _dark: "black.1000"
    }
  },
  highlight: {
    default: "blue.100",
    _dark: "blue.900"
  },
  "accent-primary": {
    "very-light": {
      default: "orange.50",
      _dark: "black.1000"
    },
    light: {
      default: "orange.100",
      _dark: "orange.100"
    },
    medium: {
      default: "orange.200",
      _dark: "orange.200"
    },
    dark: {
      default: "orange.300",
      _dark: "orange.300"
    }
  },
  "accent-secondary": {
    "grey-dark": {
      default: "blackAlpha.50",
      _dark: "black.1000"
    },
    "grey-light": {
      default: "black.100",
      _dark: "black.900"
    },
    "red-very-light": {
      default: "red.50",
      _dark: "red.100"
    },
    "red-light": {
      default: "red.100",
      _dark: "red.100"
    },
    "pink-light": {
      default: "pink.50",
      _dark: "pink.700"
    },
    "pink-medium": {
      default: "pink.100",
      _dark: "pink.800"
    },
    "blue-very-light": {
      default: "sapphire.25",
      _dark: "sapphire.50"
    },
    "blue-light": {
      default: "sapphire.50",
      _dark: "sapphire.700"
    },
    "blue-medium": {
      default: "sapphire.100",
      _dark: "sapphire.800"
    },
    "blue-dark": {
      default: "sapphire.700",
      _dark: "sapphire.200"
    },
    "cyan-light": {
      default: "cyan.50",
      _dark: "cyan.100"
    },
    "green-light": {
      default: "green.50",
      _dark: "sapphire.50"
    },
    "yellow-light": {
      default: "yellow.50",
      _dark: "yellow.100"
    }
  }
}, fr = {
  primary: {
    default: "black.800",
    _dark: "black.200"
  },
  secondary: {
    default: "black.500",
    _dark: "black.500"
  },
  tertiary: {
    default: "black.400",
    _dark: "black.600"
  },
  inverse: {
    default: "main.white",
    _dark: "black.800"
  },
  feedback: {
    success: {
      default: "green.400",
      _dark: "green.400"
    },
    alert: {
      default: "red.400",
      _dark: "red.400"
    }
  },
  accent: {
    "pink-dark": {
      default: "pink.700",
      _dark: "pink.50"
    },
    "green-dark": {
      default: "green.700",
      _dark: "green.50"
    },
    "blue-dark": {
      default: "sapphire.700",
      _dark: "sapphire.100"
    },
    "blue-very-dark": {
      default: "sapphire.900",
      _dark: "sapphire.800"
    }
  }
}, br = {
  text: {
    primary: {
      default: "black.800",
      _dark: "black.200"
    },
    secondary: {
      default: "black.600",
      _dark: "black.500"
    }
  },
  grid: {
    default: "black.300",
    _dark: "black.800"
  },
  axis: {
    default: "black.700",
    _dark: "black.300"
  },
  categorical: {
    1: {
      default: "blue.300",
      _dark: "blue.300"
    },
    2: {
      default: "orange.500",
      _dark: "orange.500"
    },
    3: {
      default: "purple.700",
      _dark: "purple.700"
    },
    4: {
      default: "red.500",
      _dark: "red.600"
    },
    5: {
      default: "pink.500",
      _dark: "pink.500"
    },
    6: {
      default: "cyan.800",
      _dark: "green.500"
    },
    7: {
      default: "red.200",
      _dark: "cyan.700"
    }
  },
  sequential: {
    blue: {
      "low-3": {
        default: "blue.200",
        _dark: "blue.800"
      },
      "low-2": {
        default: "blue.300",
        _dark: "blue.700"
      },
      "low-1": {
        default: "blue.400",
        _dark: "blue.600"
      },
      default: {
        default: "blue.500",
        _dark: "blue.500"
      },
      "high-1": {
        default: "blue.600",
        _dark: "blue.400"
      },
      "high-2": {
        default: "blue.700",
        _dark: "blue.300"
      },
      "high-3": {
        default: "blue.800",
        _dark: "blue.200"
      }
    },
    red: {
      "low-3": {
        default: "red.200",
        _dark: "red.800"
      },
      "low-2": {
        default: "red.300",
        _dark: "red.700"
      },
      "low-1": {
        default: "red.400",
        _dark: "red.600"
      },
      default: {
        default: "red.500",
        _dark: "red.500"
      },
      "high-1": {
        default: "red.600",
        _dark: "red.400"
      },
      "high-2": {
        default: "red.700",
        _dark: "red.300"
      },
      "high-3": {
        default: "red.800",
        _dark: "red.200"
      }
    }
  }
}, yr = {
  primary: "foreground.primary",
  secondary: "foreground.secondary",
  placeholder: "foreground.tertiary",
  disabled: "foreground.tertiary",
  inverse: "foreground.inverse",
  success: "foreground.feedback.success",
  alert: "foreground.feedback.alert",
  "selectable-primary": {
    default: "black.800",
    _dark: "black.800"
  }
}, xr = {
  space: mr,
  radii: pr,
  shadows: ur,
  colors: {
    border: Cr,
    background: hr,
    foreground: fr,
    text: yr,
    permissionBtn: gr,
    visualization: br,
    overlay: {
      default: "rgba(0, 0, 0, 0.64)",
      _dark: "rgba(0, 0, 0, 0.64)"
    }
  }
}, kr = {
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em",
  "3xl": "160em",
  "4xl": "240em"
}, mn = a1({
  colors: st,
  fonts: dr,
  fontSizes: sr,
  textStyles: cr,
  layerStyles: lr,
  semanticTokens: xr,
  breakpoints: kr,
  styles: ar,
  components: {
    Alert: pt,
    Button: ft,
    Divider: bt,
    Drawer: wt,
    Editable: Mt,
    Form: Ht,
    FormLabel: zt,
    Input: Pt,
    Menu: Wt,
    Modal: Ut,
    Popover: qt,
    Skeleton: Jt,
    Textarea: or,
    Tooltip: ir,
    Tabs: nr
  }
}), h = ({ name: e, className: t = "", size: o = "md", ...n }) => /* @__PURE__ */ r(
  M.i,
  {
    fontSize: `icon-${o}`,
    fontFamily: "prompt-studio-icons",
    fontStyle: "normal",
    fontWeight: "normal",
    display: "inline-block",
    textDecoration: "inherit",
    textAlign: "center",
    textTransform: "none",
    className: `icon-${e} ${t}`,
    ...n
  }
), wr = (e) => {
  const { children: t, onClose: o } = e;
  return /* @__PURE__ */ r(w, { as: "section", background: "background.accent-primary.dark", children: /* @__PURE__ */ r(w, { borderBottomWidth: "1px", children: /* @__PURE__ */ m(
    de,
    {
      color: "text.selectable-primary",
      spacing: { base: "3", md: "4" },
      justify: { base: "start", md: "space-between" },
      children: [
        /* @__PURE__ */ r(w, { boxSize: "8", display: { base: "none", md: "block" } }),
        t,
        /* @__PURE__ */ r(
          I,
          {
            color: "text.selectable-primary",
            _hover: {
              background: "transparent"
            },
            onClick: o,
            icon: /* @__PURE__ */ r(h, { name: "close" }),
            variant: "ghost",
            "aria-label": "Close banner"
          }
        )
      ]
    }
  ) }) });
}, pn = (e) => {
  const { parentName: t, children: o, onParentClick: n } = e;
  return /* @__PURE__ */ m(l1, { textStyle: "label/M/normal", children: [
    /* @__PURE__ */ r(ue, { children: /* @__PURE__ */ r(d1, { color: "foreground.secondary", onClick: n, children: t || /* @__PURE__ */ r(s1, { height: "1rem", width: "5rem" }) }) }),
    /* @__PURE__ */ r(ue, { mt: "3px", isCurrentPage: !0, children: o })
  ] });
}, Sr = {
  base: "vs-dark",
  inherit: !0,
  rules: [],
  colors: {
    "editor.background": "#0a0d15",
    "editor.foreground": "#f5f5f5",
    "editor.lineHighlightBackground": "#22252C",
    "editorCursor.foreground": "#A7A7A7",
    "editorWhitespace.foreground": "#3B3B3B",
    "editorIndentGuide.background": "#404040",
    "editorIndentGuide.activeBackground": "#707070"
  }
}, vr = (e) => {
  const { defaultCode: t, code: o, showLineNumbers: n, isEditable: i, language: a = "javascript", onChange: l } = e;
  return /* @__PURE__ */ r(
    U1,
    {
      width: "100%",
      height: "100%",
      language: a,
      defaultValue: t,
      value: o,
      theme: "ps-theme",
      options: {
        tabSize: 2,
        minimap: {
          enabled: !1
        },
        fontSize: 12,
        readOnly: !i,
        lineNumbers: n ? "on" : "off"
      },
      onChange: (c) => {
        l == null || l(c || "");
      },
      beforeMount: (c) => {
        c.editor.defineTheme("ps-theme", Sr);
      },
      onMount: async (c, s) => {
        var g;
        s.editor.setTheme("ps-theme"), s.languages.typescript.typescriptDefaults.setCompilerOptions({
          jsx: s.languages.typescript.JsxEmit.React
        }), s.languages.registerDocumentFormattingEditProvider("sql", {
          provideDocumentFormattingEdits(p, u) {
            const b = p.getValue(), y = X1(b, {
              language: "sql",
              tabWidth: u.tabSize,
              keywordCase: "upper",
              useTabs: u.insertSpaces === !1
            });
            return [
              {
                range: p.getFullModelRange(),
                text: y
              }
            ];
          }
        }), c.addCommand(s.KeyMod.CtrlCmd | s.KeyCode.KeyS, async () => {
          var p;
          await ((p = c.getAction("editor.action.formatDocument")) == null ? void 0 : p.run());
        }), await ((g = c.getAction("editor.action.formatDocument")) == null ? void 0 : g.run());
      }
    }
  );
}, A = (e) => {
  const {
    id: t,
    children: o = null,
    primaryLabel: n,
    tooltipLabel: i,
    secondaryLabel: a,
    leftIcon: l = null,
    rightIcon: c = null,
    isDisabled: s,
    isSelected: g,
    tabIndex: p,
    setRefElement: u
  } = e, { onClick: b, onMouseDown: y, onMouseEnter: k } = e;
  return /* @__PURE__ */ m(
    Ie,
    {
      id: t,
      ref: u,
      tabIndex: p,
      isDisabled: s,
      "aria-selected": g,
      paddingX: "spacing-sm",
      paddingY: "spacing-xxs",
      onClick: b,
      onMouseDown: y,
      onMouseEnter: k,
      height: "auto",
      minHeight: "2rem",
      role: "option",
      maxWidth: "20rem",
      overflow: "hidden",
      children: [
        /* @__PURE__ */ m(C, { justifyContent: "space-between", flex: "1", children: [
          /* @__PURE__ */ r(R, { placement: "right", label: i, "aria-label": n, children: /* @__PURE__ */ m(C, { alignItems: "left", gap: "spacing-xs", flex: "1", children: [
            l,
            /* @__PURE__ */ m(C, { gap: "spacing-xxs", flexDirection: "column", children: [
              /* @__PURE__ */ r(f, { noOfLines: 1, textOverflow: "ellipsis", textStyle: "label/M/regular", children: n }),
              a && /* @__PURE__ */ r(f, { noOfLines: 2, textOverflow: "ellipsis", textStyle: "label/S/regular", color: "foreground.secondary", children: a })
            ] })
          ] }) }),
          /* @__PURE__ */ r(C, { mt: "2px", justifyContent: "flex-end", color: "foreground.primary", children: c })
        ] }),
        o
      ]
    }
  );
}, xe = G1(), Er = (e) => {
  if (typeof e == "string") {
    const t = Date.parse(e);
    return isNaN(t) ? "string" : "date";
  } else {
    if (typeof e == "number")
      return "number";
    if (typeof e == "boolean")
      return "boolean";
  }
  return "unknown";
}, Lr = (e) => {
  const t = Er(e);
  return /* @__PURE__ */ r(P, { children: t === "date" ? /* @__PURE__ */ r(h, { size: "xs", name: "data-date", mr: "2px" }) : t === "string" ? /* @__PURE__ */ r(h, { size: "xs", name: "data-string", mr: "2px" }) : t === "number" ? /* @__PURE__ */ r(h, { size: "xs", name: "data-intiger", mr: "2px" }) : t === "boolean" ? /* @__PURE__ */ r(h, { size: "xs", name: "data-boolean", mr: "2px" }) : /* @__PURE__ */ r(P, {}) });
};
function _r(e) {
  switch (typeof e) {
    case "boolean":
      return e ? "TRUE" : "FALSE";
    case "number":
      return e;
    case "object":
      return e !== null ? JSON.stringify(e) : "-";
    case "undefined":
      return "-";
    default:
      return e ? String(e) : "-";
  }
}
const Fr = ({ data: e, noBorder: t, onCSVDownload: o }) => {
  const [n, i] = S([]), a = [
    // Add custom column to show row number
    xe.accessor((s, g) => g + 1, {
      header: "",
      id: "rowIndex",
      size: 20,
      cell: (s) => /* @__PURE__ */ r(M.span, { display: "block", textStyle: "paragraph/S/regular", textAlign: "center", children: s.getValue() })
    }),
    // Other columns generated dynamically based on data keys
    ...Object.keys(e[0] || {}).map((s) => {
      const g = s || "-";
      return xe.accessor((p) => p[g], {
        id: g,
        header: () => /* @__PURE__ */ m(P, { children: [
          Lr(e[0][g]),
          " ",
          g
        ] }),
        cell: (p) => {
          const u = p.getValue(), b = _r(u);
          return /* @__PURE__ */ r(f, { width: "fit-content", textStyle: "paragraph/S/regular", children: b });
        }
      });
    })
  ], l = Y1({
    data: e,
    columns: a,
    defaultColumn: {
      size: 150,
      minSize: 40,
      maxSize: 800
    },
    state: {
      sorting: n
    },
    columnResizeMode: "onChange",
    columnResizeDirection: "ltr",
    onSortingChange: i,
    getSortedRowModel: J1(),
    getCoreRowModel: K1(),
    getPaginationRowModel: q1(),
    enableMultiRowSelection: !0,
    enableRowSelection: !0,
    autoResetAll: !0
  });
  H(() => {
    l.setPageSize(30);
  }, []);
  const c = Q1(() => {
    const s = l.getFlatHeaders(), g = {};
    for (let p = 0; p < s.length; p++) {
      const u = s[p];
      g[`--header-${u.id}-size`] = u.getSize(), g[`--col-${u.column.id}-size`] = u.column.getSize();
    }
    return g;
  }, [l.getState().columnSizingInfo, l.getState().columnSizing]);
  return /* @__PURE__ */ m(C, { direction: "column", height: "100%", width: "100%", children: [
    !!l.getSelectedRowModel().rows.length && /* @__PURE__ */ r(C, { alignItems: "center", paddingY: "0.5", paddingX: "2", children: /* @__PURE__ */ m(v, { direction: "row", alignItems: "center", children: [
      /* @__PURE__ */ r(
        I,
        {
          "aria-label": "clear-selection",
          icon: /* @__PURE__ */ r(h, { name: "close" }),
          onClick: () => l.toggleAllRowsSelected(!1),
          size: "xs"
        }
      ),
      /* @__PURE__ */ m(f, { children: [
        l.getSelectedRowModel().rows.length,
        " rows selected"
      ] }),
      l.getSelectedRowModel().rows.length !== l.getCoreRowModel().rows.length && /* @__PURE__ */ m(F, { onClick: () => l.toggleAllRowsSelected(!0), children: [
        "Select all ",
        l.getCoreRowModel().rows.length,
        " rows"
      ] }),
      /* @__PURE__ */ r(se, { orientation: "vertical" }),
      /* @__PURE__ */ r(F, { onClick: () => o == null ? void 0 : o(l.getSelectedRowModel().rows.map((s) => s.original.id)), children: "Download CSV" })
    ] }) }),
    /* @__PURE__ */ r(c1, { height: "100%", overflowY: "auto", overflowX: "auto", maxWidth: "unset", children: /* @__PURE__ */ m(
      g1,
      {
        style: {
          ...c,
          width: l.getTotalSize()
        },
        children: [
          /* @__PURE__ */ r(m1, { children: l.getHeaderGroups().map((s) => /* @__PURE__ */ r(
            Ce,
            {
              background: "background.secondary",
              borderRight: t ? "none" : "1px solid",
              borderColor: "border.secondary",
              children: s.headers.map((g) => /* @__PURE__ */ r(
                p1,
                {
                  background: "background.secondary",
                  textTransform: "none",
                  borderRight: "1px solid",
                  _last: { borderRight: "none" },
                  borderColor: "border.secondary",
                  padding: "spacing-xs",
                  overflow: "hidden",
                  style: { width: `calc(var(--header-${g == null ? void 0 : g.id}-size) * 1px)` },
                  children: /* @__PURE__ */ r(R, { label: te(g.column.columnDef.header, g.getContext()), children: /* @__PURE__ */ m(C, { alignItems: "center", justifyContent: "space-between", gap: "1", flex: "1", role: "group", children: [
                    /* @__PURE__ */ r(f, { textStyle: "label/S/medium", children: te(g.column.columnDef.header, g.getContext()) }),
                    g.column.id !== "rowIndex" && l.getCoreRowModel().rows.length > 1 && /* @__PURE__ */ m(q, { size: "xs", children: [
                      /* @__PURE__ */ r(
                        K,
                        {
                          as: I,
                          size: "xs",
                          "aria-label": "sort column",
                          variant: "ghost",
                          visibility: "hidden",
                          _groupHover: { visibility: "visible" },
                          children: /* @__PURE__ */ r(h, { size: "xs", name: "more" })
                        }
                      ),
                      /* @__PURE__ */ r(Re, { children: /* @__PURE__ */ m(J, { zIndex: "popover", children: [
                        /* @__PURE__ */ r(
                          A,
                          {
                            onClick: () => g.column.toggleSorting(!1),
                            primaryLabel: "Sort ascending",
                            isDisabled: g.column.getIsSorted() === "asc"
                          }
                        ),
                        /* @__PURE__ */ r(
                          A,
                          {
                            onClick: () => g.column.toggleSorting(!0),
                            primaryLabel: "Sort descending",
                            isDisabled: g.column.getIsSorted() === "desc"
                          }
                        ),
                        g.column.getIsSorted() && /* @__PURE__ */ r(A, { onClick: () => g.column.clearSorting(), primaryLabel: "Clear sort" })
                      ] }) })
                    ] }),
                    /* @__PURE__ */ r(
                      "span",
                      {
                        onDoubleClick: () => g.column.resetSize(),
                        onMouseDown: g.getResizeHandler(),
                        onTouchStart: g.getResizeHandler(),
                        className: `resizer ${g.column.getIsResizing() ? "isResizing" : ""}`
                      }
                    )
                  ] }) })
                },
                g.id
              ))
            },
            s.id
          )) }),
          /* @__PURE__ */ r(u1, { children: l.getRowModel().rows.map((s) => /* @__PURE__ */ r(
            Ce,
            {
              borderTop: t ? "none" : "1px solid",
              borderBottom: "1px solid",
              borderRight: t ? "none" : "1px solid",
              _last: { borderBottom: t ? "none" : "1px solid", borderColor: "border.secondary" },
              borderColor: "border.secondary",
              _hover: { background: "background.light" },
              children: s.getVisibleCells().map((g, p) => /* @__PURE__ */ r(
                C1,
                {
                  width: "fit-content",
                  maxWidth: "12rem",
                  overflow: "hidden",
                  padding: "spacing-xs",
                  borderRight: "1px solid",
                  borderColor: "border.secondary",
                  _last: { borderRight: "none" },
                  borderBottom: "none",
                  textStyle: "paragraph/S/regular",
                  background: p === 0 ? "background.secondary" : "inherit",
                  children: te(g.column.columnDef.cell, g.getContext())
                },
                g.id
              ))
            },
            s.id
          )) })
        ]
      }
    ) }),
    l.getPageCount() > 1 && /* @__PURE__ */ m(
      C,
      {
        alignItems: "center",
        justifyContent: "space-between",
        borderTop: "1px solid",
        borderColor: "border.secondary",
        paddingX: "spacing-xs",
        children: [
          /* @__PURE__ */ m(f, { children: [
            l.getCoreRowModel().rows.length,
            " rows"
          ] }),
          /* @__PURE__ */ m(v, { alignItems: "center", direction: "row", justifyContent: "flex-end", children: [
            /* @__PURE__ */ r(F, { size: "sm", onClick: () => l.setPageIndex(0), disabled: !l.getCanPreviousPage(), children: "<<" }),
            /* @__PURE__ */ r(F, { size: "sm", onClick: () => l.previousPage(), disabled: !l.getCanPreviousPage(), children: "<" }),
            /* @__PURE__ */ r(F, { size: "sm", onClick: () => l.nextPage(), disabled: !l.getCanNextPage(), children: ">" }),
            /* @__PURE__ */ r(
              F,
              {
                size: "sm",
                onClick: () => l.setPageIndex(l.getPageCount() - 1),
                disabled: !l.getCanNextPage(),
                children: ">>"
              }
            ),
            /* @__PURE__ */ m(C, { alignItems: "center", height: "100%", marginLeft: "spacing-sm", marginRight: "spacing-md", children: [
              /* @__PURE__ */ r(f, { children: "Page" }),
              /* @__PURE__ */ r(
                ce,
                {
                  margin: "spacing-xxs",
                  width: "3rem",
                  size: "sm",
                  type: "number",
                  value: l.getState().pagination.pageIndex + 1,
                  onChange: (s) => l.setPageIndex(Number(s.target.value) - 1)
                }
              ),
              /* @__PURE__ */ m(f, { children: [
                "of ",
                l.getPageCount()
              ] })
            ] })
          ] })
        ]
      }
    )
  ] });
}, un = (e) => {
  const { containerRef: t, canEdit: o, name: n, onBlur: i, onDuplicate: a, onDelete: l, onSaveAsTemplate: c } = e, [s, g] = S(n), p = ee(null), b = `${Math.max(s.length * 0.69, 4)}em`;
  return H(() => {
    g(n);
  }, [n]), /* @__PURE__ */ m(P, { children: [
    /* @__PURE__ */ m(
      h1,
      {
        isDisabled: !o,
        value: s,
        border: "none",
        _focus: { outline: "none" },
        marginLeft: "-6px",
        marginTop: "-2px",
        onBlur: () => {
          i(s);
        },
        onChange: g,
        children: [
          /* @__PURE__ */ r(
            f1,
            {
              ref: p,
              noOfLines: 1,
              lineHeight: "initial",
              padding: "0 0.25rem",
              borderRadius: "radius-sm",
              border: "1px solid transparent",
              _focus: { outline: "none" },
              _hover: {
                outline: "none",
                boxShadow: "none",
                background: "background.secondary"
              }
            }
          ),
          /* @__PURE__ */ r(
            b1,
            {
              padding: "0 0.25rem",
              borderRadius: "radius-sm",
              width: b,
              _focus: { outline: "none", boxShadow: "none", background: "background.secondary" },
              placeholder: n
            }
          )
        ]
      }
    ),
    o && /* @__PURE__ */ m(q, { children: [
      /* @__PURE__ */ r(
        K,
        {
          as: I,
          size: "xs",
          marginTop: "-2px",
          maxWidth: "1rem",
          variant: "ghost",
          icon: /* @__PURE__ */ r(h, { size: "sm", name: "arrow-down-1" })
        }
      ),
      /* @__PURE__ */ r(Re, { containerRef: t, children: /* @__PURE__ */ m(J, { children: [
        c && /* @__PURE__ */ m(P, { children: [
          /* @__PURE__ */ r(
            A,
            {
              onClick: c,
              primaryLabel: "Save as Template",
              leftIcon: /* @__PURE__ */ r(h, { name: "export-3" })
            }
          ),
          /* @__PURE__ */ r(se, {})
        ] }),
        /* @__PURE__ */ r(
          A,
          {
            onClick: () => {
              var y;
              return (y = p == null ? void 0 : p.current) == null ? void 0 : y.focus();
            },
            primaryLabel: "Rename",
            leftIcon: /* @__PURE__ */ r(h, { name: "edit" })
          }
        ),
        a && /* @__PURE__ */ r(A, { onClick: a, leftIcon: /* @__PURE__ */ r(h, { name: "copy", size: "md" }), primaryLabel: "Duplicate" }),
        /* @__PURE__ */ r(A, { onClick: l, leftIcon: /* @__PURE__ */ r(h, { name: "trash", size: "md" }), primaryLabel: "Delete" })
      ] }) })
    ] })
  ] });
}, Ke = (e) => {
  const { size: t, Illustration: o = null, title: n, description: i, showBackground: a, Action: l = null } = e;
  return /* @__PURE__ */ m(
    he,
    {
      my: "1rem",
      padding: t === "sm" ? "spacing-md" : "spacing-xl",
      bg: a ? "background.secondary" : "transparent",
      borderRadius: "radius-md",
      display: "flex",
      flexDirection: "column",
      gap: "spacing-md",
      maxW: "100%",
      centerContent: !0,
      children: [
        o && /* @__PURE__ */ r(C, { justifyContent: "center", alignItems: "center", width: "10rem", height: "10rem", overflow: "hidden", children: /* @__PURE__ */ r(et, { fallback: null, children: o }) }),
        /* @__PURE__ */ m(he, { mb: l ? "spacing-md" : "0", centerContent: !0, padding: "0", gap: "spacing-xxs", children: [
          /* @__PURE__ */ r(f, { textStyle: t === "sm" ? "label/M/medium" : "label/L/medium", textAlign: "center", children: n }),
          /* @__PURE__ */ r(f, { textStyle: "label/S/regular", textAlign: "center", children: i })
        ] }),
        l
      ]
    }
  );
}, Mr = (e) => {
  const { iconName: t, title: o, onClose: n, children: i } = e, a = ee(null);
  return /* @__PURE__ */ r(w, { position: "absolute", bottom: "1", right: "1", children: /* @__PURE__ */ r(v, { direction: "row", position: "relative", children: /* @__PURE__ */ r(
    Ne,
    {
      resizeHandles: ["nw"],
      axis: "both",
      width: 600,
      height: 400,
      minConstraints: [350, 200],
      maxConstraints: [window.innerWidth, window.innerHeight],
      children: /* @__PURE__ */ m(C, { flexDirection: "column", height: "100%", width: "100%", children: [
        /* @__PURE__ */ m(v, { paddingY: "1", paddingX: "2", direction: "row", alignItems: "center", children: [
          t && /* @__PURE__ */ r(h, { name: t }),
          o && /* @__PURE__ */ r(f, { textStyle: "label/M/medium", noOfLines: 1, children: o }),
          /* @__PURE__ */ r(Z, {}),
          /* @__PURE__ */ r(I, { onClick: n, "aria-label": "close", icon: /* @__PURE__ */ r(h, { name: "close" }), variant: "ghost", size: "sm" })
        ] }),
        /* @__PURE__ */ r(se, {}),
        /* @__PURE__ */ r(C, { ref: a, flex: "1", overflow: "auto", children: i })
      ] })
    }
  ) }) });
}, Je = () => /* @__PURE__ */ r(y1, { children: /* @__PURE__ */ r(x1, {}) }), Ar = ({ file: e }) => {
  const [t, o] = S([]), [n, i] = S(!0), [a, l] = S(!1);
  return H(() => {
    e.text().then(
      (c) => rt(c, {
        header: !0,
        dynamicTyping: !0,
        worker: !0,
        complete(s) {
          o(s.data), i(!1);
        }
      })
    ).catch((c) => {
      console.error("error parsing file", { error: c }), i(!1), l(!0);
    });
  }, [e]), n ? /* @__PURE__ */ r(Je, {}) : a ? /* @__PURE__ */ r(wr, { children: "Failed to parse File" }) : t.length > 0 ? /* @__PURE__ */ r(Fr, { isReadOnly: !0, data: t }) : /* @__PURE__ */ r(Ke, { title: "Empty Table", showBackground: !1 });
}, Ir = (e) => {
  const { file: t } = e, [o, n] = S(null);
  return H(() => {
    t.text().then((i) => {
      n(i);
    });
  }, [t]), /* @__PURE__ */ r(C, { width: "100%", paddingY: "1", paddingX: "2", overflow: "auto", children: /* @__PURE__ */ r(f, { whiteSpace: "pre-wrap", overflowWrap: "break-word", textStyle: "body/M/regular", children: nt.decode(o || "") }) });
}, Rr = [
  "text/csv",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
], Cn = (e) => {
  const { file: t, isLoading: o, onClose: n, title: i, iconName: a } = e, l = Rr.includes((t == null ? void 0 : t.type) || ""), c = i || (t == null ? void 0 : t.name.split(".")[0]) || "";
  return /* @__PURE__ */ m(Mr, { iconName: a || (l ? "table" : "document-text-1"), title: c, onClose: n, children: [
    o && /* @__PURE__ */ r(Je, {}),
    !o && t && (l ? /* @__PURE__ */ r(Ar, { file: t }) : /* @__PURE__ */ r(Ir, { file: t })),
    !o && !t && /* @__PURE__ */ r(Ke, { title: "Empty Preview", description: "No data available", showBackground: !1 })
  ] });
}, Hr = (e, t) => {
  const { text: o, label: n, Icon: i, ...a } = e;
  return /* @__PURE__ */ r(R, { label: n, children: /* @__PURE__ */ m(
    v,
    {
      ref: t,
      ...a,
      height: "32px",
      borderRadius: "radius-lg",
      border: "1px solid",
      borderColor: "border.primary",
      alignItems: "center",
      justifyContent: "center",
      paddingX: "spacing-sm",
      _hover: {
        bg: "background.secondary",
        color: "foreground.primary"
      },
      cursor: "pointer",
      gap: "1",
      direction: "row",
      textStyle: "label/M/regular",
      color: "foreground.primary",
      children: [
        i,
        /* @__PURE__ */ r(f, { noOfLines: 1, children: o })
      ]
    }
  ) });
}, hn = k1(Hr), fn = (e) => {
  const [t, o] = S(!1), { headline: n, buttonText: i, notificationText: a, onDelete: l, isOpen: c, onClose: s } = e;
  return /* @__PURE__ */ m(He, { isOpen: c, onClose: s, children: [
    /* @__PURE__ */ r(ze, {}),
    /* @__PURE__ */ m(De, { children: [
      /* @__PURE__ */ r(Be, { children: /* @__PURE__ */ r(f, { textStyle: "heading/3/medium", children: n }) }),
      /* @__PURE__ */ r(Te, {}),
      /* @__PURE__ */ r(Pe, { children: a }),
      /* @__PURE__ */ r(Oe, { children: /* @__PURE__ */ m(v, { direction: "row", gap: "1", children: [
        /* @__PURE__ */ r(F, { onClick: s, children: "Close" }),
        /* @__PURE__ */ r(
          F,
          {
            isLoading: t,
            variant: "primary",
            onClick: async (g) => {
              o(!0), await l(g), s(), o(!1);
            },
            children: i
          }
        )
      ] }) })
    ] })
  ] });
}, bn = (e) => {
  const { isOpen: t, onClose: o, title: n, onRename: i, buttonText: a, defaultName: l, inputPlaceholder: c } = e, [s, g] = S(l), [p, u] = S(!1);
  return /* @__PURE__ */ m(He, { onClose: o, isOpen: t, children: [
    /* @__PURE__ */ r(ze, {}),
    /* @__PURE__ */ m(De, { children: [
      /* @__PURE__ */ r(Be, { children: /* @__PURE__ */ r(f, { textStyle: "heading/3/medium", children: n }) }),
      /* @__PURE__ */ r(Te, {}),
      /* @__PURE__ */ r(Pe, { children: /* @__PURE__ */ r(
        ce,
        {
          size: "lg",
          defaultValue: l,
          onChange: (y) => g(y.target.value),
          placeholder: c
        }
      ) }),
      /* @__PURE__ */ r(Oe, { children: /* @__PURE__ */ m(v, { direction: "row", gap: "1", children: [
        /* @__PURE__ */ r(F, { onClick: o, children: "Close" }),
        /* @__PURE__ */ r(
          F,
          {
            isLoading: p,
            isDisabled: !s || s === l,
            variant: "primary",
            onClick: async () => {
              u(!0);
              try {
                await i(s);
              } finally {
                u(!1), o();
              }
            },
            children: a
          }
        )
      ] }) })
    ] })
  ] });
}, yn = (e) => /* @__PURE__ */ r(
  C,
  {
    height: "4rem",
    minHeight: "4rem",
    paddingLeft: "spacing-xl",
    paddingRight: "spacing-md",
    bg: "background.primary",
    alignItems: "center",
    borderBottom: "1px solid",
    borderColor: "border.secondary",
    children: e.children
  }
), xn = (e) => /* @__PURE__ */ m(C, { direction: "column", height: "100%", width: "100%", children: [
  e.Banner,
  /* @__PURE__ */ r(C, { height: "100%", width: "100%", children: e.children })
] }), kn = (e) => /* @__PURE__ */ r(C, { position: "relative", flex: 1, flexDirection: "column", height: "100%", overflow: "hidden", children: e.children }), wn = (e) => /* @__PURE__ */ r(C, { paddingX: "4", paddingY: "5", gap: "3", direction: "column", overflow: "auto", children: e.children }), zr = (e) => {
  const { id: t, defaultValue: o, name: n, step: i = 1, min: a, max: l, onChange: c, description: s, readOnly: g } = e, [p, u] = S(o), b = a !== void 0 && l !== void 0, y = tt(ot(c, 540), []);
  return H(() => {
    u(o);
  }, [o]), /* @__PURE__ */ m(w, { children: [
    /* @__PURE__ */ r(R, { placement: "right", padding: "spacing-xxs", label: s, "aria-label": `${n} tooltip`, children: /* @__PURE__ */ m(C, { alignItems: "center", justifyContent: "space-between", minHeight: "32px", mb: "spacing-sm", children: [
      /* @__PURE__ */ r(f, { textStyle: "label/M/medium", children: n }),
      /* @__PURE__ */ r(
        ce,
        {
          className: "nodrag",
          readOnly: g,
          width: "56px",
          size: "sm",
          type: "number",
          value: p,
          onChange: (k) => {
            y(t, parseInt(k.target.value)), u(parseInt(k.target.value) || a || 0);
          },
          onKeyUp: (k) => {
            k.key === "Enter" && k.target.blur();
          }
        }
      )
    ] }) }),
    b && /* @__PURE__ */ m(
      w1,
      {
        isDisabled: g,
        focusThumbOnChange: !1,
        colorScheme: "black",
        value: p,
        step: i,
        min: a,
        max: l,
        "aria-label": "slider-ex-6",
        onChange: (k) => {
          u(k);
        },
        onChangeEnd: (k) => {
          c(t, k);
        },
        children: [
          /* @__PURE__ */ r(S1, { children: /* @__PURE__ */ r(v1, { background: "black" }) }),
          /* @__PURE__ */ r(E1, {})
        ]
      }
    )
  ] });
}, Sn = (e) => {
  const { params: t = [], defaultValues: o, onChange: n, readOnly: i } = e;
  return /* @__PURE__ */ r(v, { flex: "1", maxWidth: "100%", gap: "spacing-xl", children: t.map((a) => {
    if (a.type === "number") {
      const l = o[a.id] === void 0 ? a.defaultValue : o[a.id];
      return /* @__PURE__ */ r(
        zr,
        {
          readOnly: i,
          id: a.id,
          name: a.name,
          description: a.description || "",
          defaultValue: l,
          min: a.min,
          max: a.max,
          step: a.step,
          onChange: n
        },
        a.id
      );
    }
  }) });
}, ne = {
  pending: "Pending",
  viewer: "Can view",
  editor: "Can edit",
  owner: "Owner"
}, Dr = {
  pending: "permissionBtn.pending",
  viewer: "permissionBtn.default",
  editor: "permissionBtn.default",
  owner: "transparent"
}, vn = (e) => {
  const { permission: t, isDisabled: o, onPermissionChange: n } = e, i = !o && t !== "pending" && t !== "owner";
  return /* @__PURE__ */ m(q, { children: [
    /* @__PURE__ */ r(
      K,
      {
        as: C,
        onClick: (a) => {
          a.stopPropagation(), i || a.preventDefault();
        },
        cursor: i ? "pointer" : "default",
        textStyle: "label/S/medium",
        alignItems: "center",
        borderRadius: "radius-xs",
        h: "6",
        px: "1",
        bg: Dr[t],
        _hover: i ? {
          bg: "permissionBtn.default-hover"
        } : {},
        _active: i ? {
          bg: "permissionBtn.default-active"
        } : {},
        children: ne[t]
      }
    ),
    /* @__PURE__ */ m(J, { children: [
      /* @__PURE__ */ r(
        A,
        {
          primaryLabel: ne.editor,
          rightIcon: t === "editor" ? /* @__PURE__ */ r(h, { name: "check" }) : null,
          onClick: (a) => {
            a.stopPropagation(), n && t !== "editor" && n("editor");
          }
        }
      ),
      /* @__PURE__ */ r(
        A,
        {
          primaryLabel: ne.viewer,
          rightIcon: t === "viewer" ? /* @__PURE__ */ r(h, { name: "check" }) : null,
          onClick: (a) => {
            a.stopPropagation(), n && t !== "viewer" && n("viewer");
          }
        }
      )
    ] })
  ] });
}, En = (e) => {
  const { iconName: t, name: o } = e;
  return /* @__PURE__ */ m(
    M.span,
    {
      height: "24px",
      lineHeight: "24px",
      gap: "spacing-xxs",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingX: "spacing-xs",
      cursor: "default",
      borderRadius: "radius-xs",
      color: "foreground.primary",
      bg: "background.secondary",
      children: [
        /* @__PURE__ */ r(h, { mt: "2px", name: t, size: "xs" }),
        /* @__PURE__ */ r(R, { label: o, "aria-label": o, children: /* @__PURE__ */ r(M.span, { noOfLines: 1, maxW: "12rem", children: o }) }),
        /* @__PURE__ */ r(Z, {})
      ]
    }
  );
}, ke = {
  analytical: "briefcase",
  creative: "book-1",
  fast: "clock",
  research: "teacher",
  fallback: "setting-4"
}, Ln = (e) => ke[e] || ke.fallback, we = {
  file_upload: "document-upload",
  file_placeholder: "document-1",
  text_placeholder: "edit",
  text: "edit",
  file: "document-text-1",
  comment: "message-text-1",
  step: "document-text-1",
  link: "arrow-right-1",
  connector: "data",
  column: "table",
  fallback: "edit"
}, _n = (e) => we[e] || we.fallback, Se = {
  // Documents
  "text/markdown": "document-text-1",
  "text/plain": "document-text-1",
  "text/rtf": "document-text-1",
  "application/pdf": "document-text-1",
  "application/msword": "document-text-1",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "document-text-1",
  // Data files
  "text/csv": "table",
  "application/vnd.ms-excel": "table",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "table",
  "text/tab-separated-values": "table",
  // Code and structured data
  "text/json": "document-code",
  "text/html": "document-code",
  "text/xml": "document-code",
  "text/yaml": "document-code",
  "text/javascript": "document-code",
  "text/typescript": "document-code",
  "application/javascript": "document-code",
  "application/typescript": "document-code",
  "text/css": "document-code",
  "text/python": "document-code",
  "text/java": "document-code",
  "text/cpp": "document-code",
  "application/json": "document-code",
  fallback: "document-1"
}, Fn = (e) => Se[e] || Se.fallback, Br = {
  code: "code",
  connector: "data",
  json: "document-code",
  metric: "metrics",
  schema: "schema",
  secret: "key",
  table: "table",
  text: "document-text-1",
  visualization: "visualization"
}, Tr = (e) => Br[e.resourceType] || "document-1", ve = {
  idle: "credit-usage-0",
  pending: "credit-usage-0",
  running: "refresh-1",
  success: "tick-circle",
  error: "danger"
}, Pr = (e) => ve[e] || ve.idle, Mn = (e) => e.status !== "success" ? Pr(e.status) : e.type === "reflection" ? "message" : "tick-circle", Or = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_1929_524)" }, /* @__PURE__ */ d.createElement("path", { d: "M8.8125 4.5C8.75 4.4375 8.6875 4.375 8.625 4.375C8.5625 4.375 8.53125 4.40625 8.46875 4.4375C7.9375 4.84375 7.21875 6.625 6.625 8.96875H7.15625C8.1875 8.96875 9.28125 9 10.3437 9C10.0625 7.9375 9.8125 7 9.5625 6.28125C9.1875 5.1875 8.96875 4.71875 8.8125 4.5Z", fill: "#00A7CF" }), /* @__PURE__ */ d.createElement("path", { d: "M10 0C4.46875 0 0 4.46875 0 10C0 15.5313 4.46875 20 10 20C15.5313 20 20 15.5313 20 10C20 4.46875 15.5313 0 10 0ZM17.1875 10.1875L17.1563 10.2188H17.125H17.0938C17.0313 10.25 16.9375 10.2813 16.8438 10.2813H12.125C12.1562 10.4375 12.2188 10.625 12.25 10.8125C12.5 11.9375 13.1875 14.9063 13.9375 14.9063H13.9688C14.5313 14.9063 14.8438 14.0937 15.4688 12.2812V12.25C15.5625 11.9688 15.6875 11.625 15.8125 11.2812L15.8438 11.1875C15.875 11.0625 16 11 16.125 11.0312C16.25 11.0625 16.3125 11.1875 16.2812 11.3125L16.25 11.4375C16.1875 11.6562 16.125 11.9375 16.0312 12.2812C15.6562 13.875 15.0625 16.25 13.5938 16.25C12.625 16.25 12.0625 14.7187 11.8125 14.0625C11.3437 12.8437 11 11.5313 10.6875 10.2813H6.3125L5.40625 13.1875C5.28125 13.4063 5 13.4688 4.78125 13.3438C4.65625 13.25 4.5625 13.125 4.5625 12.9688V12.9375L4.625 12.625C4.75 11.875 4.90625 11.0938 5.0625 10.3125H3.21875C2.875 10.25 2.625 9.96875 2.625 9.625C2.625 9.28125 2.875 9 3.1875 8.9375C3.25 8.9375 3.34375 8.9375 3.40625 8.9375H3.5C4.09375 8.9375 4.6875 8.96875 5.375 8.96875C6.34375 5.0625 7.4375 3.09375 8.6875 3.0625C10 3.0625 11 6.09375 11.7813 9.03125C13.4063 9.0625 15.125 9.125 16.7813 9.21875H16.8438C16.875 9.21875 16.9063 9.21875 16.9375 9.21875C17.2188 9.28125 17.4063 9.5625 17.3438 9.84375C17.3438 10 17.2813 10.0937 17.1875 10.1875Z", fill: "#00A7CF" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_1929_524" }, /* @__PURE__ */ d.createElement("rect", { width: 20, height: 20, fill: "white" })))), Vr = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_1935_601)" }, /* @__PURE__ */ d.createElement("path", { d: "M4.525 18.1863L0.174375 10.6506C-0.058125 10.2481 -0.058125 9.75189 0.174375 9.34939L4.525 1.81408C4.75719 1.41189 5.18594 1.16408 5.65 1.16345H14.3553C14.8178 1.16564 15.2444 1.41345 15.4756 1.81408L19.8256 9.34939C20.0581 9.75189 20.0581 10.2481 19.8256 10.6506L15.475 18.1863C15.2428 18.5885 14.8141 18.8363 14.35 18.8369H5.64687C5.18344 18.8353 4.75625 18.5875 4.52406 18.1863H4.525Z", fill: "#4386FA" }), /* @__PURE__ */ d.createElement("path", { opacity: 0.1, d: "M12.7178 7.57343C12.7178 7.57343 13.9272 10.4744 12.2784 12.1187C10.6297 13.7631 7.6275 12.7106 7.6275 12.7106L13.7344 18.8344H14.3544C14.8188 18.8337 15.2475 18.5856 15.4794 18.1837L18.3594 13.1969L12.7178 7.57343Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { d: "M14.1459 13.5094L12.8125 12.1728C12.798 12.1579 12.7814 12.1453 12.7631 12.1353C13.3303 11.4047 13.5976 10.4854 13.5106 9.56459C13.4236 8.64379 12.9887 7.79081 12.2947 7.17944C11.6007 6.56806 10.6996 6.2443 9.77522 6.27411C8.85079 6.30391 7.9725 6.68505 7.31929 7.33986C6.66609 7.99467 6.28711 8.8739 6.25958 9.7984C6.23204 10.7229 6.55802 11.6231 7.1711 12.3156C7.78417 13.0082 8.63822 13.4409 9.55924 13.5257C10.4803 13.6104 11.3989 13.3409 12.1281 12.7719C12.1376 12.7891 12.1495 12.8049 12.1634 12.8188L13.5 14.1553C13.5393 14.1945 13.5925 14.2166 13.648 14.2166C13.7035 14.2166 13.7567 14.1945 13.7959 14.1553L14.1459 13.8053C14.1852 13.7661 14.2072 13.7129 14.2072 13.6574C14.2072 13.6019 14.1852 13.5487 14.1459 13.5094ZM9.8875 12.645C9.34667 12.6451 8.81796 12.4848 8.36825 12.1843C7.91853 11.8839 7.56801 11.4568 7.36102 10.9572C7.15402 10.4575 7.09984 9.90772 7.20534 9.37727C7.31084 8.84682 7.57127 8.35958 7.9537 7.97715C8.33612 7.59472 8.82337 7.33429 9.35382 7.22879C9.88426 7.1233 10.4341 7.17747 10.9337 7.38447C11.4334 7.59147 11.8604 7.94199 12.1609 8.3917C12.4613 8.84141 12.6216 9.37012 12.6216 9.91096C12.6215 10.636 12.3334 11.3314 11.8207 11.8441C11.308 12.3569 10.6126 12.6449 9.8875 12.645ZM8.13969 9.76502V10.895C8.31375 11.2022 8.56563 11.4585 8.87032 11.6372V9.75814L8.13969 9.76502ZM9.50688 8.82814V11.8819C9.74839 11.9264 9.99599 11.9264 10.2375 11.8819V8.82814H9.50688ZM11.6206 10.8925V10.2231H10.8906V11.6294C11.1949 11.4511 11.4469 11.1959 11.6213 10.8894L11.6206 10.8925Z", fill: "white" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_1935_601" }, /* @__PURE__ */ d.createElement("rect", { width: 20, height: 20, fill: "white" })))), Zr = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_1935_639)" }, /* @__PURE__ */ d.createElement("mask", { id: "mask0_1935_639", style: {
  maskType: "luminance"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 20, height: 20 }, /* @__PURE__ */ d.createElement("path", { d: "M19.9998 0H0V19.9998H19.9998V0Z", fill: "white" })), /* @__PURE__ */ d.createElement("g", { mask: "url(#mask0_1935_639)" }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.82 13.7995L0.527085 14.8716C0.41792 15.2145 0.265004 15.7183 0.182505 16.1666C0.0650054 16.4766 0.000839233 16.8128 0.000839233 17.1641C0.000839233 18.6124 1.095 19.8048 2.50166 19.9607C2.89748 20.0178 3.3454 20.0148 3.84748 19.9411L6.15412 19.6228C6.73412 19.5428 7.21037 19.1241 7.36453 18.5591L8.95203 12.7283L0.82 13.7995Z", fill: "url(#paint0_linear_1935_639)" }), /* @__PURE__ */ d.createElement("path", { d: "M3.06986 14.0758C0.638628 14.4525 0.139465 16.2871 0.139465 16.2871L2.46778 7.73212L14.6339 6.0863L12.9748 12.1125C12.8885 12.4354 12.6173 12.6829 12.281 12.7342L12.2131 12.7454L3.00152 14.0875L3.06986 14.0758Z", fill: "url(#paint1_linear_1935_639)" }), /* @__PURE__ */ d.createElement("path", { d: "M3.06986 14.0758C0.638628 14.4525 0.139465 16.2871 0.139465 16.2871L2.46778 7.73212L14.6339 6.0863L12.9748 12.1125C12.8885 12.4354 12.6173 12.6829 12.281 12.7342L12.2131 12.7454L3.00152 14.0875L3.06986 14.0758Z", fill: "url(#paint2_linear_1935_639)", fillOpacity: 0.8 }), /* @__PURE__ */ d.createElement("path", { d: "M4.44947 8.61742L17.9181 6.62787C18.2385 6.58412 18.4981 6.34953 18.5798 6.04245L19.9698 1.01208C19.9889 0.943742 19.9989 0.871656 19.9989 0.797492C19.9989 0.35708 19.6423 0 19.2014 0C19.1673 0 19.1331 0.00208332 19.1002 0.00624995L6.24862 1.9054C4.8528 2.12957 3.72572 3.15914 3.3599 4.50205L1.50658 11.2191C1.87865 9.86031 2.1074 9.04117 4.44947 8.61742Z", fill: "url(#paint3_linear_1935_639)" }), /* @__PURE__ */ d.createElement("path", { d: "M4.44947 8.61742L17.9181 6.62787C18.2385 6.58412 18.4981 6.34953 18.5798 6.04245L19.9698 1.01208C19.9889 0.943742 19.9989 0.871656 19.9989 0.797492C19.9989 0.35708 19.6423 0 19.2014 0C19.1673 0 19.1331 0.00208332 19.1002 0.00624995L6.24862 1.9054C4.8528 2.12957 3.72572 3.15914 3.3599 4.50205L1.50658 11.2191C1.87865 9.86031 2.1074 9.04117 4.44947 8.61742Z", fill: "url(#paint4_linear_1935_639)" }), /* @__PURE__ */ d.createElement("path", { d: "M4.44947 8.61742L17.9181 6.62787C18.2385 6.58412 18.4981 6.34953 18.5798 6.04245L19.9698 1.01208C19.9889 0.943742 19.9989 0.871656 19.9989 0.797492C19.9989 0.35708 19.6423 0 19.2014 0C19.1673 0 19.1331 0.00208332 19.1002 0.00624995L6.24862 1.9054C4.8528 2.12957 3.72572 3.15914 3.3599 4.50205L1.50658 11.2191C1.87865 9.86031 2.1074 9.04117 4.44947 8.61742Z", fill: "url(#paint5_linear_1935_639)" }), /* @__PURE__ */ d.createElement("path", { d: "M4.44947 8.61742L17.9181 6.62787C18.2385 6.58412 18.4981 6.34953 18.5798 6.04245L19.9698 1.01208C19.9889 0.943742 19.9989 0.871656 19.9989 0.797492C19.9989 0.35708 19.6423 0 19.2014 0C19.1673 0 19.1331 0.00208332 19.1002 0.00624995L6.24862 1.9054C4.8528 2.12957 3.72572 3.15914 3.3599 4.50205L1.50658 11.2191C1.87865 9.86031 2.1074 9.04117 4.44947 8.61742Z", fill: "url(#paint6_linear_1935_639)" }), /* @__PURE__ */ d.createElement("path", { d: "M4.44947 8.61742L17.9181 6.62787C18.2385 6.58412 18.4981 6.34953 18.5798 6.04245L19.9698 1.01208C19.9889 0.943742 19.9989 0.871656 19.9989 0.797492C19.9989 0.35708 19.6423 0 19.2014 0C19.1673 0 19.1331 0.00208332 19.1002 0.00624995L6.24862 1.9054C4.8528 2.12957 3.72572 3.15914 3.3599 4.50205L1.50658 11.2191C1.87865 9.86031 2.1074 9.04117 4.44947 8.61742Z", fill: "url(#paint7_linear_1935_639)" }), /* @__PURE__ */ d.createElement("path", { d: "M4.44947 8.61742L17.9181 6.62787C18.2385 6.58412 18.4981 6.34953 18.5798 6.04245L19.9698 1.01208C19.9889 0.943742 19.9989 0.871656 19.9989 0.797492C19.9989 0.35708 19.6423 0 19.2014 0C19.1673 0 19.1331 0.00208332 19.1002 0.00624995L6.24862 1.9054C4.8528 2.12957 3.72572 3.15914 3.3599 4.50205L1.50658 11.2191C1.87865 9.86031 2.1074 9.04117 4.44947 8.61742Z", fill: "url(#paint8_linear_1935_639)" }), /* @__PURE__ */ d.createElement("path", { d: "M4.44947 8.61742L17.9181 6.62787C18.2385 6.58412 18.4981 6.34953 18.5798 6.04245L19.9698 1.01208C19.9889 0.943742 19.9989 0.871656 19.9989 0.797492C19.9989 0.35708 19.6423 0 19.2014 0C19.1673 0 19.1331 0.00208332 19.1002 0.00624995L6.24862 1.9054C4.8528 2.12957 3.72572 3.15914 3.3599 4.50205L1.50658 11.2191C1.87865 9.86031 2.1074 9.04117 4.44947 8.61742Z", fill: "url(#paint9_linear_1935_639)", fillOpacity: 0.4 }), /* @__PURE__ */ d.createElement("path", { d: "M4.44943 8.61789C2.49903 8.97086 2.01487 9.59914 1.69237 10.5837L0.139465 16.2883C0.139465 16.2883 0.635711 14.472 3.03736 14.0837L12.2135 12.747L12.2815 12.7358C12.6177 12.6845 12.889 12.4366 12.9752 12.1141L14.3402 7.15668L4.44985 8.61789H4.44943Z", fill: "url(#paint10_linear_1935_639)" }), /* @__PURE__ */ d.createElement("path", { d: "M4.44943 8.61789C2.49903 8.97086 2.01487 9.59914 1.69237 10.5837L0.139465 16.2883C0.139465 16.2883 0.635711 14.472 3.03736 14.0837L12.2135 12.747L12.2815 12.7358C12.6177 12.6845 12.889 12.4366 12.9752 12.1141L14.3402 7.15668L4.44985 8.61789H4.44943Z", fill: "url(#paint11_linear_1935_639)", fillOpacity: 0.2 }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.03748 14.0838C1.00791 14.4121 0.341253 15.7563 0.182505 16.1659C0.0650054 16.4767 0.000839233 16.8129 0.000839233 17.1642C0.000839233 18.6125 1.095 19.805 2.50166 19.9608C2.89748 20.0179 3.3454 20.015 3.84748 19.9413L6.15412 19.6229C6.73412 19.5429 7.21037 19.1242 7.36453 18.5592L8.81164 13.243L3.0379 14.0842L3.03748 14.0838Z", fill: "url(#paint12_linear_1935_639)" }))), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("linearGradient", { id: "paint0_linear_1935_639", x1: 4.47622, y1: 20.0003, x2: 4.47622, y2: 12.7283, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { offset: 0.056, stopColor: "#2AAC94" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.155, stopColor: "#239C87" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.372, stopColor: "#177E71" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.588, stopColor: "#0E6961" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.799, stopColor: "#095D57" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#085954" })), /* @__PURE__ */ d.createElement("linearGradient", { id: "paint1_linear_1935_639", x1: 13.6653, y1: 14.7239, x2: 6.64316, y2: 7.0863, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { offset: 0.0417478, stopColor: "#ABE88E" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.548926, stopColor: "#2AAA92" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.906, stopColor: "#117865" })), /* @__PURE__ */ d.createElement("linearGradient", { id: "paint2_linear_1935_639", x1: -3.59109, y1: 14.3525, x2: 3.09149, y2: 12.0736, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "#6AD6F9" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#6AD6F9", stopOpacity: 0 })), /* @__PURE__ */ d.createElement("linearGradient", { id: "paint3_linear_1935_639", x1: 1.50658, y1: 5.60954, x2: 19.2944, y2: 5.60954, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { offset: 0.043, stopColor: "#25FFD4" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.874, stopColor: "#55DDB9" })), /* @__PURE__ */ d.createElement("linearGradient", { id: "paint4_linear_1935_639", x1: 8.3532, y1: 0.774161, x2: 12.1677, y2: 8.95406, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "#F4E084", stopOpacity: 0.6 }), /* @__PURE__ */ d.createElement("stop", { offset: 0.534, stopColor: "#F4E084", stopOpacity: 0 })), /* @__PURE__ */ d.createElement("linearGradient", { id: "paint5_linear_1935_639", x1: 14.7002, y1: -4.31751, x2: 19.8422, y2: 3.58086, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "#ABF5E2" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#4EE6BD" })), /* @__PURE__ */ d.createElement("linearGradient", { id: "paint6_linear_1935_639", x1: 10.7527, y1: 0, x2: 10.7527, y2: 11.2191, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "#1F937E" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#9EE09F" })), /* @__PURE__ */ d.createElement("linearGradient", { id: "paint7_linear_1935_639", x1: 10.7527, y1: 0, x2: 10.7527, y2: 11.2191, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "#1F937E" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#C0ECC7" })), /* @__PURE__ */ d.createElement("linearGradient", { id: "paint8_linear_1935_639", x1: 1.50658, y1: 3.1233, x2: 17.5298, y2: 10.5638, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "#6AD6F9" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.229501, stopColor: "#60E9D0" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.650711, stopColor: "#6DE9BB" }), /* @__PURE__ */ d.createElement("stop", { offset: 0.99354, stopColor: "#ABE88E" })), /* @__PURE__ */ d.createElement("linearGradient", { id: "paint9_linear_1935_639", x1: 2.9889, y1: 4.51562, x2: 11.7016, y2: 6.44266, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "white", stopOpacity: 0 }), /* @__PURE__ */ d.createElement("stop", { offset: 0.458511, stopColor: "white" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "white", stopOpacity: 0 })), /* @__PURE__ */ d.createElement("linearGradient", { id: "paint10_linear_1935_639", x1: 5.87789, y1: 11.9798, x2: 6.08377, y2: 5.86975, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { offset: 0.204642, stopColor: "#063D3B", stopOpacity: 0 }), /* @__PURE__ */ d.createElement("stop", { offset: 0.58553, stopColor: "#063D3B", stopOpacity: 0.236587 }), /* @__PURE__ */ d.createElement("stop", { offset: 0.872285, stopColor: "#063D3B", stopOpacity: 0.75 })), /* @__PURE__ */ d.createElement("linearGradient", { id: "paint11_linear_1935_639", x1: -0.595154, y1: 11.3721, x2: 6.85048, y2: 12.7724, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "white", stopOpacity: 0 }), /* @__PURE__ */ d.createElement("stop", { offset: 0.458511, stopColor: "white" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "white", stopOpacity: 0 })), /* @__PURE__ */ d.createElement("linearGradient", { id: "paint12_linear_1935_639", x1: 4.7833, y1: 17.9854, x2: 3.33093, y2: 10.8822, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { offset: 0.064, stopColor: "#063D3B", stopOpacity: 0 }), /* @__PURE__ */ d.createElement("stop", { offset: 0.17, stopColor: "#063D3B", stopOpacity: 0.135 }), /* @__PURE__ */ d.createElement("stop", { offset: 0.562, stopColor: "#063D3B", stopOpacity: 0.599 }), /* @__PURE__ */ d.createElement("stop", { offset: 0.85, stopColor: "#063D3B", stopOpacity: 0.9 }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#063D3B" })), /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_1935_639" }, /* @__PURE__ */ d.createElement("rect", { width: 20, height: 20, fill: "white" })))), Wr = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_1935_565)" }, /* @__PURE__ */ d.createElement("path", { d: "M19.9225 12.575C19.8026 12.2053 19.4884 11.9477 19.0822 11.8858C18.8906 11.8567 18.6712 11.8691 18.4116 11.9236C17.9592 12.0187 17.6235 12.0549 17.3785 12.0619C18.3032 10.4722 19.0551 8.6593 19.488 6.9528C20.188 4.19351 19.8139 2.93646 19.3769 2.36783C18.2201 0.862899 16.5324 0.0543728 14.4962 0.0295885C13.4101 0.0160911 12.4565 0.234448 11.9592 0.391431C11.496 0.308283 10.998 0.261819 10.4755 0.253212C9.49611 0.237316 8.63071 0.454685 7.89126 0.901463C7.48179 0.760563 6.82484 0.561865 6.06609 0.435027C4.28152 0.136721 2.84327 0.369186 1.79126 1.12589C0.51736 2.04211 -0.0732175 3.63395 0.0360204 5.85726C0.0706624 6.56317 0.458515 8.71085 1.06914 10.7477C1.42009 11.9184 1.79431 12.8907 2.18142 13.6376C2.73039 14.6967 3.31778 15.3205 3.97722 15.5444C4.34688 15.6698 5.01842 15.7576 5.7248 15.1587C5.81431 15.2691 5.93371 15.3788 6.09228 15.4807C6.29357 15.6099 6.53976 15.7156 6.78558 15.7782C7.67163 16.0037 8.50156 15.9473 9.2096 15.6312C9.21394 15.7594 9.21731 15.8819 9.22018 15.9877C9.22489 16.1593 9.22951 16.3275 9.2357 16.4848C9.27764 17.5487 9.34872 18.3759 9.55935 18.9547C9.57089 18.9865 9.58646 19.035 9.6029 19.0864C9.70794 19.414 9.88369 19.9624 10.3307 20.3919C10.7936 20.8368 11.3535 20.9732 11.8663 20.9732C12.1235 20.9732 12.3689 20.9389 12.5841 20.8919C13.3514 20.7245 14.2227 20.4694 14.853 19.5556C15.4489 18.6918 15.7386 17.3906 15.791 15.3405C15.7978 15.2825 15.8041 15.2272 15.8101 15.1744C15.8142 15.1388 15.8183 15.1024 15.8225 15.0661L15.9629 15.0786L15.9991 15.0811C16.7805 15.1174 17.736 14.9487 18.3228 14.6711C18.7865 14.452 20.2723 13.6534 19.9225 12.575Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { d: "M18.5864 12.7847C16.2629 13.2727 16.1032 12.4717 16.1032 12.4717C18.5564 8.76547 19.5819 4.06091 18.6969 2.90949C16.2826 -0.231354 12.1033 1.25406 12.0335 1.29263L12.0111 1.29672C11.552 1.1997 11.0383 1.1419 10.461 1.1323C9.40964 1.11476 8.61218 1.41293 8.00706 1.88016C8.00706 1.88016 0.551584 -1.24704 0.898327 5.81321C0.972092 7.31523 3.01269 17.1781 5.44664 14.1991C6.33625 13.1097 7.19579 12.1887 7.19579 12.1887C7.62272 12.4774 8.1338 12.6247 8.6696 12.5718L8.71121 12.5358C8.69828 12.6711 8.70419 12.8034 8.72789 12.96C8.10087 13.6733 8.28512 13.7985 7.03168 14.0612C5.76336 14.3274 6.50844 14.8012 6.99491 14.925C7.58466 15.0752 8.94904 15.2879 9.87094 13.9739L9.83417 14.1238C10.0799 14.3242 10.2524 15.4271 10.2235 16.4268C10.1945 17.4266 10.1752 18.113 10.3688 18.6491C10.5624 19.1853 10.7553 20.3916 12.4031 20.0321C13.7799 19.7316 14.4934 18.9531 14.5927 17.6545C14.6631 16.7313 14.8225 16.8678 14.8326 16.0423L14.9605 15.6516C15.1079 14.4001 14.9839 13.9963 15.8321 14.1841L16.0383 14.2026C16.6626 14.2315 17.4798 14.1003 17.9593 13.8734C18.992 13.3854 19.6045 12.5706 18.5863 12.7847H18.5864Z", fill: "#336791" }), /* @__PURE__ */ d.createElement("path", { d: "M8.44349 6.48496C8.23416 6.45528 8.0445 6.48275 7.94857 6.55668C7.89457 6.5983 7.8779 6.6465 7.87342 6.67971C7.86136 6.7676 7.92187 6.86477 7.95901 6.9149C8.06413 7.05679 8.21776 7.15432 8.36982 7.17582C8.39185 7.17892 8.41374 7.18043 8.43554 7.18043C8.68912 7.18043 8.91961 6.97942 8.93993 6.83105C8.96534 6.64523 8.70039 6.52136 8.44349 6.48496Z", fill: "white" }), /* @__PURE__ */ d.createElement("path", { d: "M15.3797 6.49086C15.3598 6.34521 15.1051 6.30368 14.8636 6.33787C14.6224 6.37211 14.3884 6.48296 14.4079 6.62893C14.4236 6.74246 14.6249 6.93627 14.8632 6.93622C14.8833 6.93622 14.9036 6.93486 14.9241 6.93194C15.0832 6.90951 15.1999 6.80666 15.2553 6.74735C15.3398 6.65706 15.3886 6.55632 15.3797 6.49086Z", fill: "white" }), /* @__PURE__ */ d.createElement("path", { d: "M19.3595 12.7293C19.271 12.4565 18.9858 12.3687 18.5121 12.4684C17.1054 12.764 16.6017 12.5592 16.4362 12.4352C17.5296 10.7392 18.4291 8.68926 18.9143 6.77654C19.1442 5.87052 19.2711 5.02912 19.2815 4.34334C19.2929 3.5905 19.1671 3.03739 18.9074 2.69949C17.8603 1.33724 16.3236 0.606547 14.4634 0.586465C13.1846 0.571839 12.1042 0.905088 11.8947 0.99877C11.4536 0.887076 10.9727 0.818507 10.4492 0.80976C9.4892 0.793958 8.65941 1.02798 7.97234 1.50495C7.67391 1.39189 6.90264 1.12232 5.9595 0.967637C4.32883 0.700276 3.03308 0.902831 2.10837 1.56985C1.005 2.36577 0.495624 3.78849 0.59433 5.79843C0.62754 6.47471 1.00592 8.55495 1.60315 10.5472C2.38925 13.1693 3.24371 14.6537 4.14283 14.9591C4.24805 14.9948 4.36943 15.0198 4.5032 15.0198C4.83119 15.0198 5.23327 14.8693 5.65165 14.3572C6.34657 13.5059 6.99539 12.7927 7.23456 12.5335C7.588 12.7267 7.97622 12.8345 8.37341 12.8453C8.3741 12.8559 8.37516 12.8665 8.37609 12.877C8.29641 12.9732 8.23105 13.0576 8.17535 13.1296C7.9002 13.4852 7.84292 13.5592 6.95719 13.7449C6.70528 13.7979 6.03604 13.9383 6.02629 14.4159C6.01562 14.9377 6.81724 15.1568 6.9086 15.18C7.22689 15.2612 7.5335 15.3012 7.82592 15.3012C8.53715 15.3011 9.16297 15.0632 9.66315 14.6027C9.64772 16.463 9.72394 18.296 9.94329 18.8545C10.1229 19.3117 10.5619 20.4291 11.9483 20.429C12.1517 20.429 12.3757 20.4049 12.622 20.3512C14.0689 20.0353 14.6972 19.3842 14.9403 17.9487C15.0704 17.1815 15.2936 15.3494 15.3986 14.3667C15.6201 14.4371 15.9054 14.4693 16.2138 14.4692C16.8569 14.4692 17.599 14.3301 18.0644 14.1102C18.5872 13.863 19.5306 13.2563 19.3595 12.7293ZM15.9138 6.08879C15.909 6.37891 15.8698 6.64227 15.8282 6.9172C15.7835 7.21288 15.7372 7.51857 15.7256 7.88967C15.7141 8.25081 15.7583 8.62629 15.8012 8.98936C15.8878 9.72273 15.9766 10.4778 15.6327 11.2228C15.5793 11.1262 15.5277 11.0207 15.4804 10.904C15.4377 10.7985 15.3449 10.629 15.2164 10.3945C14.7165 9.48166 13.5457 7.34399 14.145 6.4717C14.3235 6.212 14.7765 5.94511 15.9138 6.08879ZM14.5353 1.17395C16.202 1.21144 17.5204 1.84628 18.4539 3.06076C19.1699 3.99232 18.3815 8.23106 16.0992 11.8878C16.0767 11.8587 16.0537 11.8292 16.03 11.799C16.0205 11.7869 16.0109 11.7747 16.0011 11.7622C16.5909 10.7705 16.4755 9.78937 16.3729 8.91943C16.3307 8.56243 16.2909 8.22523 16.301 7.90853C16.3115 7.57274 16.3551 7.28488 16.3972 7.00647C16.4491 6.66334 16.5018 6.30837 16.4873 5.88985C16.4981 5.84597 16.5025 5.7941 16.4968 5.73254C16.4597 5.33119 16.0097 4.13021 15.0925 3.04303C14.5908 2.44849 13.8591 1.78308 12.8601 1.33428C13.2898 1.2436 13.8775 1.15905 14.5353 1.17395ZM5.20893 13.9824C4.748 14.5466 4.42967 14.4385 4.325 14.403C3.64292 14.1713 2.85156 12.7036 2.15382 10.3761C1.55008 8.36213 1.19724 6.33701 1.16934 5.76913C1.08117 3.97318 1.50874 2.7215 2.44024 2.04888C3.95618 0.95428 6.44856 1.60944 7.45003 1.94175C7.43562 1.95619 7.42066 1.96973 7.40639 1.98441C5.76301 3.67431 5.802 6.56152 5.80602 6.73798C5.80588 6.80608 5.81147 6.90248 5.81918 7.03511C5.84745 7.52068 5.90006 8.42449 5.7595 9.44803C5.62883 10.3992 5.91678 11.3301 6.54939 12.0021C6.61488 12.0717 6.68324 12.137 6.75387 12.1985C6.47225 12.5055 5.86029 13.1845 5.20893 13.9824ZM6.96509 11.5965C6.45521 11.0549 6.22366 10.3014 6.32971 9.52921C6.47816 8.44796 6.42334 7.50629 6.39391 7.0004C6.3898 6.92962 6.38615 6.86759 6.38398 6.81863C6.62408 6.60192 7.73664 5.99492 8.53003 6.18002C8.89216 6.26449 9.11271 6.51548 9.20445 6.9473C9.67918 9.18274 9.26731 10.1145 8.93636 10.8632C8.86814 11.0174 8.80371 11.1632 8.74865 11.3141L8.70602 11.4307C8.59803 11.7255 8.49756 11.9996 8.4353 12.2599C7.89331 12.2582 7.36602 12.0225 6.96509 11.5965ZM7.04828 14.6113C6.89003 14.5711 6.74768 14.5011 6.66417 14.4431C6.73391 14.4097 6.85807 14.3643 7.07336 14.3191C8.11535 14.1007 8.27622 13.9466 8.62763 13.4923C8.70823 13.3881 8.79955 13.27 8.92602 13.1262C8.92606 13.1261 8.92611 13.1261 8.92615 13.126C9.11456 12.9113 9.2007 12.9477 9.35696 13.0137C9.48361 13.0671 9.60694 13.2287 9.65696 13.4065C9.68061 13.4905 9.70722 13.65 9.62024 13.774C8.88615 14.8205 7.8165 14.8071 7.04828 14.6113ZM12.5013 19.778C11.2266 20.0561 10.7753 19.3939 10.4779 18.6368C10.2859 18.1481 10.1916 15.9441 10.2585 13.5103C10.2594 13.4779 10.2549 13.4466 10.2461 13.4172C10.2385 13.3605 10.2268 13.3031 10.2105 13.2453C10.1109 12.8911 9.86837 12.5949 9.57738 12.4721C9.46177 12.4233 9.24953 12.3338 8.99452 12.4002C9.04893 12.1721 9.14324 11.9145 9.24546 11.6355L9.28837 11.5182C9.33669 11.3859 9.39724 11.2488 9.46135 11.1038C9.80768 10.3204 10.282 9.24741 9.76722 6.82338C9.57438 5.91548 8.9305 5.47214 7.95438 5.57509C7.36916 5.63674 6.83382 5.87715 6.5668 6.015C6.50939 6.04463 6.45687 6.07322 6.40782 6.10111C6.48232 5.1863 6.76394 3.47674 7.81724 2.39511C8.48038 1.71413 9.36361 1.37783 10.4397 1.39593C12.5601 1.4313 13.9197 2.53921 14.6871 3.46244C15.3483 4.25803 15.7063 5.05941 15.8492 5.49161C14.7747 5.38039 14.0438 5.59639 13.6733 6.13567C12.8673 7.30877 14.1142 9.58573 14.7135 10.68C14.8234 10.8806 14.9183 11.0539 14.9481 11.1275C15.1433 11.6091 15.3959 11.9306 15.5804 12.1653C15.637 12.2372 15.6918 12.307 15.7335 12.3679C15.4081 12.4635 14.8235 12.6842 14.8767 13.7875C14.8338 14.3412 14.5282 16.9332 14.373 17.849C14.1681 19.0589 13.7308 19.5096 12.5013 19.778ZM17.822 13.5785C17.4892 13.7358 16.9322 13.8538 16.4031 13.8791C15.8187 13.907 15.5213 13.8124 15.4513 13.7543C15.4184 13.0667 15.6698 12.9949 15.9358 12.9188C15.9776 12.9068 16.0184 12.8952 16.0577 12.8812C16.0822 12.9015 16.109 12.9216 16.1383 12.9413C16.608 13.257 17.4458 13.291 18.6285 13.0425C18.6329 13.0415 18.6372 13.0407 18.6415 13.0398C18.482 13.1916 18.209 13.3955 17.822 13.5785Z", fill: "white" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_1935_565" }, /* @__PURE__ */ d.createElement("rect", { width: 20, height: 21, fill: "white" })))), $r = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 20 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_1929_523)" }, /* @__PURE__ */ d.createElement("path", { d: "M0 8.68924C0 8.32054 0.445777 8.13588 0.706492 8.39661L2.60333 10.2935C2.86405 10.5542 2.6794 10.9999 2.3107 10.9999H0.413852C0.185288 10.9999 0 10.8147 0 10.5861V8.68924ZM0 6.69125C0 6.801 0.0436022 6.90628 0.121214 6.98388L4.01607 10.8787C4.09368 10.9563 4.19895 10.9999 4.3087 10.9999H6.44799C6.81669 10.9999 7.00135 10.5542 6.74062 10.2935L0.706492 4.25933C0.445777 3.9986 0 4.18326 0 4.55196V6.69125ZM0 2.55396C0 2.66372 0.0436022 2.76898 0.121214 2.84659L8.15335 10.8787C8.23094 10.9563 8.33623 10.9999 8.44598 10.9999H10.5853C10.954 10.9999 11.1386 10.5542 10.8779 10.2935L0.706492 0.122047C0.445781 -0.138664 0 0.0459807 0 0.414682V2.55396ZM4.13728 2.55396C4.13728 2.66372 4.1809 2.76898 4.2585 2.84659L11.7054 10.2935C11.9661 10.5542 12.4118 10.3695 12.4118 10.0008V7.86154C12.4118 7.75178 12.3682 7.6465 12.2906 7.5689L4.84377 0.122043C4.58304 -0.138668 4.13728 0.0459807 4.13728 0.414682V2.55396ZM8.98105 0.122047C8.72033 -0.138668 8.27456 0.0459807 8.27456 0.414682V2.55396C8.27456 2.66372 8.31818 2.76898 8.39578 2.84659L11.7054 6.15618C11.9661 6.4169 12.4118 6.23224 12.4118 5.86354V3.72426C12.4118 3.6145 12.3682 3.50922 12.2906 3.43162L8.98105 0.122047Z", fill: "#F9BD2B" }), /* @__PURE__ */ d.createElement("path", { d: "M17.599 8.73997L13.7035 4.84446C13.4428 4.58374 12.997 4.7684 12.997 5.1371V10.586C12.997 10.8146 13.1823 10.9999 13.4109 10.9999H19.4451C19.6737 10.9999 19.859 10.8146 19.859 10.586V10.0898C19.859 9.86126 19.6729 9.67876 19.4462 9.64925C18.7507 9.55866 18.1 9.24098 17.599 8.73997ZM14.9829 9.67598C14.6175 9.67598 14.3209 9.37942 14.3209 9.01403C14.3209 8.64859 14.6175 8.35203 14.9829 8.35203C15.3483 8.35203 15.6449 8.64859 15.6449 9.01403C15.6449 9.37942 15.3483 9.67598 14.9829 9.67598Z", fill: "black" }), /* @__PURE__ */ d.createElement("path", { d: "M0.671488 8.36506L0.706492 8.39656L2.60334 10.2934C2.85271 10.5428 2.69461 10.9615 2.35773 10.9974L2.3107 10.9999H0.413852C0.201614 10.9999 0.0266905 10.8401 0.00278429 10.6343L0 10.5861V8.6892C0 8.33653 0.407856 8.15224 0.671488 8.36506ZM0.671488 4.22786L0.706492 4.25937L4.13728 7.69016V11L0.121214 6.98392C0.0565376 6.91922 0.0154788 6.83535 0.00358911 6.74568L0 6.69129V4.552C0 4.19933 0.407856 4.01504 0.671488 4.22786ZM0 0.41468C0 0.0620098 0.407856 -0.122265 0.671488 0.0905434L0.706492 0.122045L4.13728 3.55284V6.86266L0.121214 2.84659C0.0565376 2.78192 0.0154788 2.69804 0.00358911 2.60836L0 2.55396V0.41468Z", fill: "#1D4AFF" }), /* @__PURE__ */ d.createElement("path", { d: "M4.13729 3.55288L8.15335 7.56894C8.21805 7.63361 8.25909 7.7175 8.27098 7.80718L8.27457 7.86158V11L4.2585 6.98392C4.19384 6.91922 4.15277 6.83535 4.14088 6.74568L4.13729 6.69129V3.55288ZM4.13729 7.69008L6.74062 10.2934C6.99001 10.5428 6.8319 10.9615 6.49501 10.9974L6.44799 10.9999H4.13729V7.69008ZM4.80877 0.0905434L4.84377 0.122045L8.15335 3.43162C8.21805 3.49628 8.25909 3.58017 8.27098 3.66986L8.27457 3.72425V6.86266L4.2585 2.84659C4.19384 2.78192 4.15277 2.69804 4.14088 2.60836L4.13729 2.55396V0.41468C4.13729 0.0620098 4.54516 -0.122265 4.80877 0.0905434Z", fill: "#F54E00" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_1929_523" }, /* @__PURE__ */ d.createElement("rect", { width: 19.859, height: 11, fill: "white" })))), jr = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 20 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_1929_522)" }, /* @__PURE__ */ d.createElement("path", { d: "M8.32195 1.5268C8.96648 0.854555 9.86492 0.43786 10.8578 0.43786C12.1777 0.43786 13.3301 1.17359 13.9437 2.26741C14.4922 2.02163 15.0863 1.89629 15.6869 1.89629C18.068 1.89629 19.9984 3.84304 19.9984 6.24556C19.9984 8.64807 18.068 10.5948 15.6869 10.5948C15.3955 10.5948 15.1123 10.5655 14.8373 10.5102C14.2969 11.4738 13.2666 12.1249 12.0866 12.1249C11.5918 12.1249 11.1247 12.0109 10.708 11.8075C10.1611 13.0966 8.8851 13.9984 7.39747 13.9984C5.84962 13.9984 4.52963 13.0185 4.02345 11.6447C3.79721 11.6919 3.56772 11.7163 3.3366 11.7163C1.49415 11.7179 1.24284e-05 10.2074 1.24284e-05 8.34531C-0.00324278 7.14406 0.63315 6.0307 1.66831 5.42356C1.45672 4.93687 1.34767 4.41112 1.3493 3.88048C1.3493 1.73678 3.08921 3.50851e-06 5.23439 3.50851e-06C6.44532 -0.00162421 7.5879 0.563194 8.32195 1.5268Z", fill: "#00A1E0" }), /* @__PURE__ */ d.createElement("path", { d: "M6.73991 7.43379C6.73991 7.45332 6.72689 7.4696 6.70736 7.4696H6.39974C6.38021 7.4696 6.36719 7.45332 6.36719 7.43379V4.95966C6.36719 4.94013 6.38021 4.92548 6.39974 4.92548H6.70736C6.72689 4.92548 6.73991 4.94176 6.73991 4.95966V7.43379ZM11.9189 4.92711C11.9271 4.93036 11.9482 4.94176 11.9401 4.9678L11.8506 5.21196C11.8441 5.22986 11.8376 5.24126 11.8001 5.22986C11.7497 5.21358 11.6976 5.20545 11.6455 5.20545C11.5999 5.20545 11.5576 5.21196 11.5218 5.22335C11.4844 5.23475 11.4518 5.25591 11.4242 5.28358C11.3883 5.31776 11.3607 5.36008 11.3428 5.40728C11.3005 5.52936 11.2842 5.66121 11.2809 5.66935H11.652C11.6829 5.66935 11.6927 5.684 11.6911 5.70678L11.6471 5.94769C11.6406 5.9835 11.6081 5.98187 11.6081 5.98187H11.2256L10.9652 7.45984C10.9424 7.59168 10.9082 7.7219 10.8626 7.84886C10.8219 7.95629 10.7796 8.03442 10.7113 8.10767C10.6527 8.1744 10.5794 8.22649 10.4964 8.25742C10.4199 8.28672 10.3223 8.30137 10.2148 8.30137C10.1644 8.30137 10.1091 8.29974 10.0456 8.28509C10.0098 8.27695 9.97396 8.26718 9.93978 8.25416C9.92513 8.24928 9.91374 8.23137 9.92188 8.20696C9.93001 8.18417 9.99837 7.99698 10.0081 7.97094C10.0195 7.94164 10.0505 7.95303 10.0505 7.95303C10.0716 7.96117 10.0846 7.96768 10.1123 7.97257C10.14 7.97745 10.1774 7.98233 10.2051 7.98233C10.2555 7.98233 10.3011 7.97582 10.3418 7.9628C10.3906 7.94815 10.4183 7.91885 10.4476 7.88141C10.4785 7.84235 10.5029 7.78863 10.529 7.71539C10.555 7.64214 10.5778 7.5461 10.5973 7.43054L10.8577 5.97861H10.6022C10.5713 5.97861 10.5615 5.96396 10.5648 5.94117L10.6071 5.70027C10.6136 5.66609 10.6462 5.66609 10.6462 5.66609H10.9082L10.9229 5.58796C10.9619 5.3552 11.04 5.17778 11.1556 5.06221C11.2712 4.94501 11.4372 4.88641 11.6471 4.88641C11.7074 4.88641 11.7594 4.88967 11.805 4.89781C11.849 4.9092 11.8815 4.91571 11.9189 4.92711ZM14.7786 5.72957C14.7673 5.7605 14.7119 5.92001 14.6908 5.9721C14.6826 5.99163 14.6712 6.00628 14.6484 6.00303C14.6484 6.00303 14.5817 5.98838 14.5215 5.98838C14.4792 5.98838 14.4189 5.99326 14.3652 6.00954C14.3115 6.02582 14.2627 6.05511 14.222 6.09581C14.1797 6.1365 14.1455 6.19347 14.1211 6.26672C14.0967 6.33997 14.082 6.45553 14.082 6.5711V7.43542C14.082 7.45495 14.0674 7.47123 14.0479 7.47123H13.7435C13.724 7.47123 13.7077 7.45658 13.7077 7.43542V5.70516C13.7077 5.68562 13.7223 5.66935 13.7419 5.66935H14.0397C14.0592 5.66935 14.0739 5.68562 14.0739 5.70516V5.84677C14.1178 5.78654 14.1976 5.73445 14.2692 5.7019C14.3408 5.66935 14.4222 5.64493 14.5687 5.65307C14.6436 5.65795 14.7428 5.67911 14.7624 5.68562C14.777 5.69376 14.7852 5.71167 14.7786 5.72957C14.7786 5.72794 14.7786 5.72794 14.7786 5.72957ZM4.96745 7.1408C4.96745 7.1408 5.07162 7.22219 5.30762 7.20754C5.47363 7.19777 5.62012 7.16685 5.62012 7.16685V6.63947C5.62012 6.63947 5.47201 6.61505 5.30599 6.61342C5.06999 6.61017 4.96908 6.69806 4.9707 6.69806C4.90072 6.7469 4.86654 6.82014 4.86654 6.92269C4.86654 6.9878 4.87793 7.03826 4.90072 7.07407C4.91537 7.09523 4.92188 7.10499 4.96745 7.1408ZM5.42806 6.32694C5.42806 6.32694 5.51921 6.33508 5.61849 6.34973V6.3009C5.61849 6.14627 5.58594 6.07302 5.52246 6.02419C5.45736 5.97536 5.36133 5.94931 5.236 5.94931C5.236 5.94931 4.95443 5.94606 4.73145 6.06651C4.72168 6.07302 4.71192 6.07628 4.71192 6.07628C4.71192 6.07628 4.68425 6.08604 4.67448 6.05674L4.5931 5.837C4.58008 5.80445 4.60287 5.79142 4.60287 5.79142C4.70703 5.71004 4.95931 5.66121 4.95931 5.66121C5.06185 5.6433 5.16602 5.63354 5.27018 5.63191C5.5013 5.63191 5.68034 5.68562 5.80241 5.79142C5.92448 5.89885 5.98633 6.07139 5.98633 6.30253V7.3638C5.98633 7.3638 5.98796 7.39473 5.96029 7.40124C5.96029 7.40124 5.91797 7.41263 5.87891 7.4224C5.83984 7.43054 5.69987 7.45984 5.58594 7.47937C5.46875 7.4989 5.35156 7.50867 5.23438 7.50867C5.12207 7.50867 5.0179 7.49727 4.92839 7.47774C4.84375 7.45984 4.764 7.42565 4.69238 7.37519C4.62728 7.32799 4.5752 7.26614 4.54102 7.19452C4.50521 7.12127 4.48731 7.03337 4.48731 6.9292C4.48731 6.82828 4.50846 6.73876 4.54915 6.66225C4.58984 6.58575 4.64681 6.52227 4.7168 6.47181C4.79004 6.41972 4.87142 6.38229 4.95768 6.3595C5.04883 6.33508 5.14323 6.32369 5.24414 6.32369C5.32064 6.32043 5.38086 6.32206 5.42806 6.32694ZM7.47233 6.38229H8.29915C8.29102 6.27648 8.26986 6.18045 8.22266 6.10883C8.15104 5.99977 8.05013 5.94117 7.89714 5.94117C7.74414 5.94117 7.63672 6.0014 7.56511 6.10883C7.51953 6.18045 7.48861 6.2716 7.47233 6.38229ZM8.6263 6.13976C8.70117 6.40019 8.66211 6.62644 8.66048 6.63947C8.65723 6.66876 8.6263 6.66876 8.6263 6.66876L7.46745 6.66714C7.47559 6.84293 7.51628 6.96826 7.60254 7.05291C7.68718 7.13592 7.81901 7.18801 7.99968 7.18963C8.27474 7.18963 8.39356 7.13429 8.47656 7.10336C8.47656 7.10336 8.50749 7.09197 8.52051 7.1229L8.59538 7.3345C8.61003 7.37031 8.59863 7.38171 8.58561 7.38984C8.51237 7.43054 8.33659 7.50541 8.0013 7.50541C7.83854 7.50541 7.69694 7.48262 7.58138 7.43705C7.4707 7.39635 7.37142 7.32962 7.29004 7.24335C7.21354 7.15871 7.15495 7.05779 7.1224 6.94873C7.08659 6.82828 7.06869 6.70457 7.07031 6.57924C7.07031 6.44739 7.08659 6.32369 7.12077 6.20975C7.15169 6.09906 7.2054 5.99814 7.27702 5.90862C7.35026 5.82235 7.44141 5.75236 7.54395 5.70516C7.65137 5.6547 7.78158 5.63028 7.92643 5.63028C8.04037 5.63028 8.1543 5.65307 8.25846 5.69702C8.33171 5.72794 8.40495 5.78491 8.47819 5.86467C8.52539 5.91839 8.59701 6.02907 8.6263 6.13976ZM16.7578 6.38229H17.5846C17.5765 6.27648 17.5553 6.18045 17.5081 6.10883C17.4349 5.99977 17.3356 5.94117 17.1826 5.94117C17.0296 5.94117 16.9222 6.0014 16.8506 6.10883C16.8034 6.18045 16.7725 6.2716 16.7578 6.38229ZM17.9102 6.13976C17.985 6.40019 17.946 6.62644 17.9443 6.63947C17.9411 6.66876 17.9102 6.67039 17.9102 6.67039L16.7513 6.66876C16.7578 6.84456 16.8001 6.96989 16.8864 7.05453C16.9694 7.13755 17.1029 7.18963 17.2835 7.19126C17.5586 7.19126 17.6758 7.13592 17.7588 7.10499C17.7588 7.10499 17.7913 7.0936 17.8027 7.12453L17.8776 7.33613C17.8923 7.37194 17.8809 7.38333 17.8678 7.39147C17.7946 7.43216 17.6188 7.50704 17.2852 7.50704C17.1224 7.50704 16.9808 7.48425 16.8652 7.43868C16.7546 7.39798 16.6553 7.33125 16.5739 7.24498C16.4958 7.16034 16.4388 7.05942 16.4063 6.95036C16.3704 6.82991 16.3525 6.7062 16.3542 6.58087C16.3542 6.44902 16.3704 6.32532 16.4046 6.21138C16.4388 6.09581 16.4909 5.99489 16.5609 5.91025C16.6341 5.82398 16.7253 5.75399 16.8278 5.70678C16.9336 5.65632 17.0654 5.63191 17.2103 5.63191C17.334 5.63191 17.4479 5.65795 17.5423 5.69864C17.6156 5.72957 17.6872 5.78654 17.762 5.8663C17.8092 5.91839 17.8809 6.02907 17.9102 6.13976ZM16.1572 7.14731L16.2402 7.38008C16.2516 7.40775 16.2272 7.42077 16.2272 7.42077C16.097 7.47123 15.918 7.50704 15.7422 7.50704C15.446 7.50704 15.2181 7.42077 15.0651 7.25312C14.9137 7.08546 14.8372 6.85595 14.8372 6.5711C14.8372 6.43926 14.8568 6.31555 14.8942 6.20324C14.9316 6.0893 14.987 5.99001 15.0602 5.90536C15.1367 5.8191 15.2311 5.75073 15.3353 5.70516C15.4443 5.65632 15.5729 5.63191 15.7161 5.63191C15.8138 5.63191 15.9001 5.63842 15.9733 5.64819C16.0531 5.66121 16.1572 5.68888 16.2012 5.70678C16.2093 5.71004 16.2321 5.72143 16.2223 5.74748C16.1898 5.83863 16.1686 5.89885 16.1377 5.98187C16.1247 6.01768 16.097 6.00628 16.097 6.00628C15.9847 5.97047 15.8773 5.9542 15.7357 5.9542C15.5664 5.9542 15.4395 6.01117 15.3564 6.12185C15.2718 6.23254 15.2262 6.37903 15.2246 6.57273C15.2246 6.78596 15.2767 6.94385 15.3711 7.04151C15.4655 7.13917 15.5973 7.18801 15.7633 7.18801C15.8301 7.18801 15.8936 7.18312 15.9505 7.17498C16.0075 7.16685 16.0596 7.14894 16.11 7.12941C16.1133 7.12615 16.1458 7.11476 16.1572 7.14731ZM13.0029 6.5711C13.0029 6.37252 12.9655 6.21626 12.8939 6.1072C12.8223 5.99814 12.7116 5.94606 12.5602 5.94606C12.4089 5.94606 12.2998 5.99814 12.2282 6.1072C12.1566 6.21626 12.1208 6.37252 12.1208 6.5711C12.1208 6.76968 12.1566 6.92594 12.2298 7.03663C12.3014 7.14569 12.4089 7.1994 12.5619 7.1994C12.7148 7.1994 12.8239 7.14569 12.8955 7.03663C12.9655 6.92757 13.0029 6.76968 13.0029 6.5711ZM13.3447 6.20324C13.3789 6.31555 13.3952 6.44088 13.3952 6.5711C13.3952 6.70295 13.3789 6.82665 13.3447 6.93897C13.3138 7.04802 13.2617 7.14894 13.1885 7.23684C13.1169 7.32148 13.0273 7.38984 12.9248 7.43542C12.819 7.48262 12.6969 7.50704 12.557 7.50704C12.417 7.50704 12.2949 7.48262 12.1908 7.43542C12.0898 7.38984 11.9987 7.32148 11.9271 7.23684C11.8555 7.14894 11.8034 7.04802 11.7708 6.93897C11.7367 6.82014 11.7188 6.69481 11.7204 6.5711C11.7204 6.43926 11.7367 6.31555 11.7708 6.20324C11.805 6.0893 11.8571 5.99001 11.9255 5.90536C11.9971 5.82072 12.0882 5.75236 12.1891 5.70516C12.2933 5.65632 12.417 5.63191 12.5553 5.63191C12.6937 5.63191 12.8174 5.65632 12.9232 5.70516C13.0273 5.75399 13.1169 5.82072 13.1868 5.90536C13.2601 5.99001 13.3122 6.09092 13.3447 6.20324ZM8.903 7.25963L8.98438 7.035C8.99577 6.99756 9.02995 7.01221 9.03809 7.0171C9.06087 7.03012 9.07715 7.04314 9.10645 7.05942C9.3457 7.21079 9.56543 7.21242 9.63542 7.21242C9.81283 7.21242 9.9235 7.11801 9.9235 6.99105V6.98291C9.9235 6.84456 9.7526 6.79247 9.55567 6.73225L9.51172 6.7176C9.23991 6.64109 8.95182 6.52878 8.95182 6.18696V6.18045C8.95182 5.85491 9.21387 5.62865 9.58984 5.62865H9.63053C9.85026 5.62865 10.0651 5.69213 10.2181 5.78654C10.2311 5.79468 10.2458 5.81096 10.2376 5.83375C10.2295 5.85328 10.1611 6.03721 10.1546 6.05837C10.14 6.09581 10.1009 6.07139 10.1009 6.07139C9.93978 5.98675 9.76074 5.94117 9.58008 5.93792C9.42057 5.93792 9.31804 6.02256 9.31804 6.1365V6.14301C9.31804 6.27648 9.49382 6.33345 9.69727 6.40019L9.73145 6.41158C10.0016 6.49623 10.2897 6.61505 10.2897 6.94059V6.9471C10.2897 7.29869 10.0342 7.51681 9.62402 7.51681C9.4222 7.51681 9.23014 7.48588 9.02669 7.37682C8.98763 7.35403 8.9502 7.33613 8.91276 7.30846C8.90788 7.30032 8.88998 7.29381 8.903 7.25963ZM2.89714 7.25963L2.97852 7.035C2.99154 6.99594 3.02083 7.00896 3.03223 7.0171C3.05501 7.03012 3.07129 7.04314 3.10059 7.05942C3.33984 7.21079 3.55957 7.21242 3.62956 7.21242C3.80859 7.21242 3.91927 7.11801 3.91927 6.99105V6.98291C3.91927 6.84456 3.74837 6.79247 3.55143 6.73225L3.50749 6.7176C3.23731 6.64109 2.94759 6.52878 2.94759 6.18696V6.18045C2.94759 5.85491 3.20964 5.62865 3.58561 5.62865H3.6263C3.84603 5.62865 4.05925 5.69213 4.21387 5.78654C4.22852 5.79468 4.24154 5.81096 4.2334 5.83375L4.15039 6.05837C4.13574 6.09581 4.09505 6.07139 4.09505 6.07139C3.93392 5.98675 3.75651 5.94117 3.57422 5.93792C3.41471 5.93792 3.31218 6.02256 3.31218 6.1365V6.14301C3.31218 6.27648 3.48796 6.33345 3.69141 6.40019L3.72559 6.41158C3.99577 6.49623 4.28386 6.61505 4.28386 6.94059V6.9471C4.28386 7.29869 4.02832 7.51681 3.61817 7.51681C3.41634 7.51681 3.22428 7.48588 3.02083 7.37682C2.98177 7.35403 2.94434 7.33613 2.9069 7.30846C2.90202 7.30032 2.88412 7.29381 2.89714 7.25963Z", fill: "white" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_1929_522" }, /* @__PURE__ */ d.createElement("rect", { width: 20, height: 14, fill: "white" })))), Nr = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 20 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_1929_520)" }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.4061 8.20564L16.1574 9.50134L18.4061 10.7861C18.5406 10.8638 18.6584 10.9673 18.7529 11.0906C18.8474 11.2138 18.9167 11.3545 18.9568 11.5046C18.9969 11.6546 19.0071 11.8111 18.9868 11.9651C18.9664 12.1191 18.9159 12.2675 18.8382 12.402C18.7605 12.5365 18.657 12.6543 18.5338 12.7488C18.4105 12.8433 18.2698 12.9126 18.1198 12.9527C17.9697 12.9928 17.8132 13.003 17.6593 12.9827C17.5053 12.9623 17.3568 12.9119 17.2223 12.8341L13.1932 10.5131C13.0086 10.4062 12.8562 10.2515 12.7521 10.0653C12.6481 9.87905 12.5962 9.66818 12.602 9.45492C12.6052 9.36254 12.6194 9.27086 12.6444 9.18185C12.7268 8.88337 12.9229 8.62902 13.1905 8.47325L17.2196 6.16037C17.3547 6.08232 17.5038 6.03167 17.6585 6.01132C17.8131 5.99097 17.9703 6.00132 18.1209 6.04177C18.2716 6.08222 18.4128 6.15199 18.5365 6.24708C18.6601 6.34216 18.7638 6.4607 18.8416 6.59591C18.9198 6.72994 18.9705 6.87816 18.9909 7.03196C19.0112 7.18575 19.0009 7.34207 18.9604 7.49182C18.9198 7.64158 18.85 7.7818 18.7548 7.90433C18.6597 8.02687 18.5411 8.12929 18.4061 8.20564ZM16.2775 14.4862L12.2498 12.1692C12.0696 12.0658 11.8655 12.0113 11.6577 12.0112C11.4499 12.0112 11.2458 12.0654 11.0655 12.1687C10.8852 12.272 10.735 12.4206 10.63 12.5998C10.5249 12.7791 10.4686 12.9827 10.4667 13.1905V17.819C10.4771 18.1265 10.6066 18.4179 10.8278 18.6318C11.0491 18.8457 11.3447 18.9652 11.6525 18.9652C11.9602 18.9652 12.2558 18.8457 12.4771 18.6318C12.6983 18.4179 12.8278 18.1265 12.8382 17.819V15.2248L15.0924 16.5205C15.2269 16.5983 15.3754 16.6489 15.5294 16.6693C15.6834 16.6898 15.8399 16.6797 15.99 16.6396C16.1402 16.5995 16.2809 16.5303 16.4043 16.4358C16.5276 16.3414 16.6312 16.2236 16.709 16.0891C16.7868 15.9546 16.8373 15.8061 16.8578 15.6521C16.8782 15.4981 16.8681 15.3416 16.828 15.1914C16.788 15.0413 16.7187 14.9006 16.6243 14.7772C16.5298 14.6539 16.412 14.5503 16.2775 14.4725V14.4862ZM11.6354 9.95873L9.95602 11.6176C9.89857 11.671 9.82411 11.7025 9.74576 11.7064H9.25287C9.17471 11.7017 9.1005 11.6703 9.04261 11.6176L7.37281 9.95327C7.32057 9.89627 7.2897 9.82293 7.28543 9.74574V9.25422C7.28994 9.17667 7.32076 9.10298 7.37281 9.04532L9.04261 7.38098C9.10063 7.32864 9.17485 7.2978 9.25287 7.2936H9.74576C9.82391 7.29724 9.89831 7.32816 9.95602 7.38098L11.6299 9.04532C11.6816 9.10311 11.7119 9.17681 11.7159 9.25422V9.74574C11.7122 9.82279 11.6818 9.89614 11.6299 9.95327L11.6354 9.95873ZM10.2974 9.49725C10.2909 9.41765 10.2577 9.34258 10.2031 9.28425L9.71845 8.80502C9.66037 8.75278 9.58619 8.72195 9.50819 8.71764H9.49044C9.4128 8.72171 9.33897 8.75259 9.28155 8.80502L8.79685 9.28425C8.74482 9.34288 8.71446 9.41758 8.71084 9.49588V9.51363C8.71428 9.59076 8.74472 9.66422 8.79685 9.72116L9.28428 10.199C9.34182 10.2513 9.41558 10.2821 9.49317 10.2864H9.51092C9.58892 10.2821 9.6631 10.2513 9.72118 10.199L10.2059 9.71706C10.2582 9.66001 10.2895 9.5868 10.2946 9.50953L10.2974 9.49725ZM2.72111 4.5165L6.75022 6.82665C6.93062 6.93003 7.13492 6.98441 7.34285 6.98441C7.55077 6.98441 7.75507 6.93001 7.93547 6.82663C8.11587 6.72325 8.26609 6.57448 8.37121 6.39509C8.47633 6.2157 8.5327 6.01193 8.53471 5.80402V1.17963C8.52427 0.872098 8.39477 0.580653 8.17353 0.366794C7.95229 0.152936 7.65662 0.0333929 7.34892 0.0333929C7.04121 0.0333929 6.74554 0.152936 6.5243 0.366794C6.30306 0.580653 6.17356 0.872098 6.16312 1.17963V3.77376L3.90622 2.47669C3.77175 2.39888 3.62327 2.34831 3.46925 2.32788C3.31523 2.30745 3.1587 2.31755 3.00859 2.35762C2.85848 2.39768 2.71773 2.46692 2.59438 2.56138C2.47102 2.65584 2.36748 2.77367 2.28967 2.90814C2.21185 3.04261 2.16129 3.1911 2.14085 3.34511C2.12042 3.49913 2.13053 3.65566 2.17059 3.80577C2.21065 3.95588 2.27989 4.09663 2.37435 4.21999C2.46881 4.34334 2.58664 4.44688 2.72111 4.5247V4.5165ZM11.563 6.98503C11.8009 7.00385 12.039 6.95005 12.2457 6.83075L16.2734 4.50968C16.4079 4.43186 16.5257 4.32832 16.6202 4.20497C16.7146 4.08162 16.7839 3.94087 16.8239 3.79076C16.864 3.64064 16.8741 3.48411 16.8537 3.3301C16.8333 3.17608 16.7827 3.0276 16.7049 2.89312C16.6271 2.75865 16.5235 2.64082 16.4002 2.54636C16.2768 2.4519 16.1361 2.38266 15.9859 2.3426C15.6828 2.26169 15.3599 2.30452 15.0883 2.46168L12.8341 3.76967V1.17553C12.8237 0.868002 12.6942 0.576557 12.473 0.362698C12.2517 0.14884 11.9561 0.0292969 11.6484 0.0292969C11.3406 0.0292969 11.045 0.14884 10.8237 0.362698C10.6025 0.576557 10.473 0.868002 10.4626 1.17553V5.80402C10.4622 6.10368 10.5756 6.3923 10.7799 6.61154C10.9842 6.83078 11.2641 6.96427 11.563 6.98503ZM7.43835 12.0149C7.20038 11.9956 6.9622 12.0494 6.75568 12.1692L2.72111 14.4807C2.44953 14.6379 2.2515 14.8965 2.17059 15.1996C2.08968 15.5028 2.13251 15.8257 2.28967 16.0973C2.44682 16.3689 2.70543 16.5669 3.00859 16.6478C3.31175 16.7287 3.63464 16.6859 3.90622 16.5287L6.16312 15.233V17.8272C6.17356 18.1347 6.30306 18.4261 6.5243 18.64C6.74554 18.8538 7.04121 18.9734 7.34892 18.9734C7.65662 18.9734 7.95229 18.8538 8.17353 18.64C8.39477 18.4261 8.52427 18.1347 8.53471 17.8272V13.1905C8.5341 12.8923 8.42074 12.6054 8.21738 12.3874C8.01403 12.1694 7.73573 12.0363 7.43835 12.0149ZM6.34608 9.84814C6.42385 9.59237 6.41213 9.31774 6.31285 9.06953C6.21357 8.82133 6.03265 8.61437 5.79994 8.4828L1.77494 6.1631C1.5031 6.0074 1.18073 5.96552 0.878137 6.04661C0.575547 6.12769 0.317303 6.32515 0.159746 6.59591C0.0817434 6.72991 0.0310846 6.87804 0.0106997 7.03174C-0.0096853 7.18544 0.000608182 7.34166 0.0409847 7.49136C0.0813612 7.64106 0.151019 7.78126 0.245929 7.90387C0.340839 8.02647 0.459118 8.12904 0.593922 8.20564L2.84263 9.50134L0.593922 10.7861C0.459448 10.8637 0.341565 10.9669 0.247003 11.09C0.152442 11.2132 0.0830531 11.3537 0.0427995 11.5036C0.00254588 11.6535 -0.00778446 11.8099 0.0123983 11.9638C0.0325811 12.1177 0.0828817 12.2662 0.160428 12.4006C0.237975 12.5351 0.341249 12.653 0.464353 12.7475C0.587458 12.8421 0.727982 12.9115 0.877903 12.9518C1.02782 12.992 1.18421 13.0023 1.33812 12.9822C1.49203 12.962 1.64046 12.9117 1.77494 12.8341L5.79994 10.5131C6.05914 10.3683 6.25382 10.1307 6.34471 9.84814H6.34608ZM19.0642 2.17222H18.8826V2.39477H19.0628C19.1461 2.39477 19.1993 2.35654 19.1993 2.28555C19.1993 2.21455 19.1502 2.17222 19.0628 2.17222H19.0642ZM18.6628 1.96742H19.0724C19.2935 1.96742 19.441 2.08894 19.441 2.27736C19.4417 2.3298 19.4284 2.38149 19.4025 2.42709C19.3766 2.47269 19.339 2.51055 19.2935 2.53677L19.4533 2.76615V2.81257H19.2225L19.0628 2.59411H18.8826V2.81257H18.6614L18.6628 1.96742ZM19.796 2.40706C19.8026 2.3037 19.7877 2.20009 19.7522 2.10278C19.7168 2.00548 19.6615 1.9166 19.5898 1.84178C19.5182 1.76695 19.4319 1.70781 19.3362 1.6681C19.2405 1.62839 19.1377 1.60897 19.0341 1.61107C18.5822 1.61107 18.2818 1.93739 18.2818 2.40706C18.2818 2.85489 18.5822 3.20169 19.0341 3.20169C19.1377 3.20417 19.2407 3.18507 19.3365 3.1456C19.4324 3.10613 19.5189 3.04715 19.5907 2.97241C19.6625 2.89767 19.7179 2.80881 19.7535 2.71148C19.7891 2.61415 19.804 2.51048 19.7974 2.40706H19.796ZM19.9844 2.40706C19.9844 2.93818 19.6294 3.38191 19.0287 3.38191C18.4279 3.38191 18.088 2.93408 18.088 2.40706C18.088 1.88004 18.4388 1.43221 19.0287 1.43221C19.6185 1.43221 19.983 1.87458 19.983 2.40706H19.9844Z", fill: "#29B5E8" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_1929_520" }, /* @__PURE__ */ d.createElement("rect", { width: 19.983, height: 19, fill: "white" })))), Ur = {
  amplitude: Or,
  bigquery: Vr,
  ms_fabric_sql: Zr,
  postgres: Wr,
  posthog: $r,
  salesforce: jr,
  snowflake: Nr
}, N = {
  xxs: "10px",
  xs: "14px",
  sm: "16px",
  md: "20px",
  lg: "24px",
  xl: "28px"
}, Xr = (e) => {
  const { connectorType: t, size: o, ...n } = e, i = Ur[e.connectorType];
  return i ? /* @__PURE__ */ r(
    w,
    {
      mt: "1px",
      height: N[o || "md"],
      width: N[o || "md"],
      minH: N[o || "md"],
      minW: N[o || "md"],
      ...n,
      children: /* @__PURE__ */ r(i, {})
    }
  ) : /* @__PURE__ */ r(h, { name: "data", size: "xs", ...n });
}, An = (e) => {
  const { referenceId: t, onRemove: o } = e;
  return /* @__PURE__ */ m(
    M.span,
    {
      height: "24px",
      lineHeight: "24px",
      gap: "spacing-xxs",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingX: "spacing-xs",
      borderRadius: "radius-xs",
      color: "foreground.feedback.alert",
      bg: "background.accent-secondary.red-light",
      _hover: {
        bg: "background.accent-secondary.red-light"
      },
      children: [
        /* @__PURE__ */ r(h, { mr: "spacing-xxs", name: "danger", size: "xs" }),
        /* @__PURE__ */ r(M.span, { noOfLines: 1, maxW: "17.5rem", children: "Missing Reference" }),
        /* @__PURE__ */ r(Z, {}),
        !!o && /* @__PURE__ */ r(
          I,
          {
            color: "foreground.feedback.alert",
            "aria-label": "Remove reference",
            icon: /* @__PURE__ */ r(h, { name: "close", size: "xs" }),
            size: "xxs",
            ml: "1",
            variant: "ghost",
            _hover: {
              bg: "transparent"
            },
            onClick: (n) => {
              n.stopPropagation(), o == null || o(t);
            },
            display: o ? "block" : "none"
          }
        )
      ]
    }
  );
}, Ee = (e) => {
  const { resource: t, onSelect: o, onRemove: n } = e, { resourceId: i, name: a } = t, l = Tr(t), c = t.connectorType;
  return /* @__PURE__ */ m(
    M.span,
    {
      height: "24px",
      lineHeight: "24px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingX: "spacing-xs",
      cursor: o ? "pointer" : "default",
      borderRadius: "radius-xs",
      color: "color.primary",
      bg: "background.secondary",
      _hover: {
        bg: "background.tertiary"
      },
      onClick: (s) => {
        s.stopPropagation(), o == null || o(i);
      },
      children: [
        c && /* @__PURE__ */ r(Xr, { connectorType: c, size: "xs", mr: "spacing-xs" }),
        !c && /* @__PURE__ */ r(h, { mr: "spacing-xs", name: l, size: "xs" }),
        /* @__PURE__ */ r(R, { label: a, "aria-label": a, children: /* @__PURE__ */ r(M.span, { noOfLines: 1, maxW: "14rem", children: a }) }),
        /* @__PURE__ */ r(Z, {}),
        !!n && /* @__PURE__ */ r(
          I,
          {
            "aria-label": "Remove reference",
            icon: /* @__PURE__ */ r(h, { name: "close", size: "xs" }),
            size: "xxs",
            ml: "1",
            variant: "ghost",
            _hover: {
              bg: "transparent"
            },
            onClick: (s) => {
              s.stopPropagation(), n == null || n(i);
            },
            display: n ? "block" : "none"
          }
        )
      ]
    }
  );
}, Gr = ({
  button: e,
  links: t,
  accordionIndex: o,
  activeLink: n,
  handleClick: i,
  onHide: a
}) => /* @__PURE__ */ r(Ve, { border: "none", children: ({ isExpanded: l }) => /* @__PURE__ */ m(P, { children: [
  /* @__PURE__ */ m(
    Ze,
    {
      p: "spacing-xs",
      paddingLeft: "spacing-md",
      borderRadius: "radius-xs",
      bg: n === e.name ? "background.secondary" : "inherit",
      color: n === e.name ? "foreground.primary" : "inherit",
      _hover: { background: "background.secondary", textColor: "foreground.primary" },
      opacity: e.hidden || e.disabled ? 0.5 : 1,
      cursor: e.disabled ? "not-allowed" : "pointer",
      disabled: e.disabled,
      children: [
        /* @__PURE__ */ r(
          L1,
          {
            orientation: "vertical",
            mr: "spacing-xxs",
            transform: l ? "rotate(0deg)" : "rotate(-90deg)",
            transition: "transform 0.2s"
          }
        ),
        /* @__PURE__ */ r(h, { name: "folder", mr: "spacing-xxs", size: "sm" }),
        /* @__PURE__ */ r(M.span, { flex: "1", textAlign: "left", noOfLines: 1, children: e.name }),
        a && /* @__PURE__ */ r(R, { label: e.hidden ? "Show this to the AI" : "Hide this from the AI", children: /* @__PURE__ */ r(
          I,
          {
            ml: "spacing-sm",
            size: "xs",
            variant: "ghost",
            "aria-label": "Hide",
            icon: /* @__PURE__ */ r(h, { name: e.hidden ? "eye-slash" : "eye", size: "xs" }),
            onClick: (c) => {
              c.stopPropagation(), a(e.name);
            }
          }
        ) })
      ]
    }
  ),
  /* @__PURE__ */ r(We, { p: 0, children: /* @__PURE__ */ r(_1, { listStyleType: "none", m: 0, children: t.map((c) => {
    const s = `${e.name}-${c.name}`, g = e.hidden || c.hidden;
    return /* @__PURE__ */ m(
      F1,
      {
        cursor: c.disabled ? "not-allowed" : "pointer",
        borderRadius: "radius-xs",
        display: "flex",
        paddingLeft: "spacing-xxl",
        paddingRight: "spacing-xs",
        py: "spacing-xs",
        _hover: {
          textDecoration: "none",
          background: "background.accent-secondary.grey-dark",
          textColor: "foreground.primary"
        },
        bg: n === s ? "background.accent-secondary.grey-dark" : "inherit",
        color: n === s ? "foreground.primary" : "inherit",
        opacity: g || c.disabled ? 0.5 : 1,
        onClick: () => {
          c.disabled || i(s, o);
        },
        children: [
          /* @__PURE__ */ r(h, { name: "table", mr: "spacing-xxs", size: "sm" }),
          /* @__PURE__ */ r(M.span, { flex: "1", noOfLines: 1, children: c.name }),
          a && /* @__PURE__ */ r(
            I,
            {
              ml: "spacing-sm",
              size: "xs",
              variant: "ghost",
              "aria-label": "Hide",
              icon: /* @__PURE__ */ r(h, { name: g ? "eye-slash" : "eye", size: "xs" }),
              onClick: (p) => {
                p.stopPropagation(), a(s);
              }
            }
          )
        ]
      },
      s
    );
  }) }) })
] }) }), Yr = ({ allowMultiple: e, data: t, onClick: o, onHide: n }) => {
  const [i, a] = S(0), [l, c] = S(null), s = (g, p) => {
    o == null || o(g), c(g), a(p);
  };
  return /* @__PURE__ */ r(
    X,
    {
      width: "100%",
      defaultIndex: [i],
      allowMultiple: e,
      textStyle: "label/M/regular",
      textColor: "foreground.secondary",
      children: t.map((g, p) => /* @__PURE__ */ r(
        Gr,
        {
          button: g.button,
          links: g.links,
          accordionIndex: p,
          activeLink: l,
          handleClick: s,
          onHide: n
        },
        p
      ))
    }
  );
}, In = (e) => {
  const { schemas: t = {}, onHideItem: o, onSelectSchema: n, onSelectTable: i } = e, a = Object.entries(t).map(([l, c]) => ({
    button: {
      name: l,
      hidden: c.hidden
    },
    links: Object.entries({ ...c.tables, ...c.views || {} }).map(([s, g]) => ({
      name: s,
      hidden: g.hidden
    }))
  }));
  return /* @__PURE__ */ r(
    Yr,
    {
      allowMultiple: !0,
      data: a,
      onHide: o,
      onClick: (l) => {
        const [c, s] = l.split("-");
        if (s) {
          i == null || i(c, s);
          return;
        }
        n == null || n(c || l);
      }
    }
  );
}, Rn = (e) => {
  const { title: t, children: o, textStyle: n = "heading/2" } = e;
  return /* @__PURE__ */ m(C, { flex: "1", alignItems: "center", justifyContent: "space-between", height: "3rem", children: [
    /* @__PURE__ */ r(f, { as: "h1", textStyle: n, children: t }),
    /* @__PURE__ */ r(v, { direction: "row", children: o })
  ] });
}, Hn = (e) => /* @__PURE__ */ r(
  C,
  {
    borderRight: "1px solid",
    borderRightColor: "border.secondary",
    direction: "column",
    bg: "background.primary",
    padding: "spacing-md",
    paddingTop: "1rem",
    height: "100%",
    width: "16.25rem",
    children: e.children
  }
), zn = (e) => {
  const { label: t, Icon: o = null } = e;
  return /* @__PURE__ */ m(
    C,
    {
      flex: "1",
      justifyContent: "space-between",
      tabIndex: 0,
      borderRadius: "radius-md",
      gap: "spacing-sm",
      h: "3rem",
      minH: "3rem",
      alignItems: "center",
      px: "2",
      textStyle: "label/M/medium",
      color: "foreground.primary",
      children: [
        /* @__PURE__ */ r(f, { noOfLines: 1, children: t }),
        o
      ]
    }
  );
}, Dn = (e) => {
  const [t, o] = S(!1), { tooltip: n, label: i, isDisabled: a, onClick: l, Icon: c = null, isSelected: s = !1, tag: g } = e;
  return /* @__PURE__ */ r(R, { label: n, "aria-label": n, children: /* @__PURE__ */ m(
    C,
    {
      tabIndex: 0,
      onMouseEnter: () => o(!0),
      onMouseLeave: () => o(!1),
      _hover: a ? {} : {
        bg: "background.accent-primary.very-light",
        color: "foreground.primary"
      },
      borderRadius: "radius-md",
      gap: "spacing-sm",
      cursor: a ? "not-allowed" : "pointer",
      h: "3rem",
      minHeight: "3rem",
      alignItems: "center",
      px: "2",
      onClick: a ? void 0 : l,
      textStyle: "label/M/medium",
      color: s ? "foreground.primary" : "foreground.secondary",
      bg: s ? "background.accent-primary.very-light" : "transparent",
      children: [
        c && /* @__PURE__ */ r(C, { minWidth: "20px", children: c }),
        /* @__PURE__ */ r(f, { noOfLines: 1, children: i }),
        g && t && /* @__PURE__ */ r(M1, { textStyle: "label/M/regular", size: "sm", colorScheme: "purple", children: g })
      ]
    }
  ) });
}, Bn = (e) => {
  const { onClick: t, primaryLabel: o, secondaryLabel: n, isSelected: i, isDisabled: a } = e;
  return /* @__PURE__ */ r(
    Ie,
    {
      isDisabled: a,
      paddingY: "1",
      onClick: t,
      height: "auto",
      minHeight: "2rem",
      role: "option",
      maxWidth: "32rem",
      borderRadius: "radius-sm",
      children: /* @__PURE__ */ m(C, { justifyContent: "space-between", flex: "1", children: [
        /* @__PURE__ */ r(C, { alignItems: "left", gap: "0.5", flexDirection: "column", flex: "1", children: /* @__PURE__ */ m(C, { gap: "1", alignItems: "center", children: [
          /* @__PURE__ */ r(
            $e,
            {
              name: o,
              textStyle: "heading/2",
              borderRadius: "radius-lg",
              borderWidth: "2px",
              color: "text.selectable-primary",
              backgroundColor: "background.accent-secondary.red-light",
              borderColor: "white"
            }
          ),
          /* @__PURE__ */ m(v, { spacing: "0", children: [
            /* @__PURE__ */ r(f, { textStyle: "label/M/regular", children: o }),
            n && /* @__PURE__ */ r(f, { textStyle: "label/S/regular", color: "foreground.secondary", children: n })
          ] })
        ] }) }),
        /* @__PURE__ */ r(C, { mt: "2px", justifyContent: "flex-end", children: i && /* @__PURE__ */ r(h, { name: "check" }) })
      ] })
    }
  );
}, Tn = (e) => {
  const { onOpen: t, onClose: o, isOpen: n } = A1(), { teamName: i, teamRole: a, children: l, isEmpty: c } = e;
  return /* @__PURE__ */ m(q, { isOpen: n, onOpen: t, onClose: o, placement: "bottom", offset: [40, 8], children: [
    /* @__PURE__ */ r(R, { label: i, placement: "top", children: /* @__PURE__ */ r(
      K,
      {
        width: "100%",
        borderRadius: "radius-sm",
        padding: "1",
        _active: {
          backgroundColor: "background.secondary"
        },
        _hover: {
          backgroundColor: "background.secondary"
        },
        onClick: (s) => {
          c && (s.preventDefault(), s.stopPropagation());
        },
        children: /* @__PURE__ */ m(C, { cursor: "pointer", tabIndex: 0, direction: "row", gap: "1", justifyContent: "space-between", children: [
          /* @__PURE__ */ m(C, { h: "3rem", alignItems: "center", children: [
            /* @__PURE__ */ r(
              $e,
              {
                size: "md",
                color: "text.selectable-primary",
                backgroundColor: "background.accent-secondary.red-light",
                name: i,
                textStyle: "heading/2",
                borderRadius: "radius-lg",
                borderColor: "white",
                borderWidth: "2px"
              }
            ),
            /* @__PURE__ */ m(v, { px: "0.5rem", spacing: "0.25rem", children: [
              /* @__PURE__ */ r(f, { noOfLines: 1, color: "foreground.primary", textStyle: "label/M/medium", textAlign: "left", children: i }),
              /* @__PURE__ */ r(f, { noOfLines: 1, color: "foreground.secondary", textStyle: "label/S/regular", textAlign: "left", children: a })
            ] })
          ] }),
          /* @__PURE__ */ r(C, { alignItems: "center", children: !c && /* @__PURE__ */ r(h, { name: "chevron-double" }) })
        ] })
      }
    ) }),
    /* @__PURE__ */ r(J, { borderRadius: "radius-md", minW: "19rem", px: "spacing-xs", py: "spacing-xs", children: /* @__PURE__ */ r(I1, { children: l }) })
  ] });
}, Pn = (e) => {
  const { title: t, description: o, picture: n, isBlank: i, isDisabled: a, onClick: l, icon: c } = e, s = typeof n == "string";
  return /* @__PURE__ */ m(
    C,
    {
      _hover: {
        borderColor: "border.accents.blue-dark"
      },
      tabIndex: 0,
      opacity: a ? 0.5 : 1,
      cursor: a ? "not-allowed" : "pointer",
      onClick: a ? void 0 : l,
      w: "12.5rem",
      minW: "12.5rem",
      gap: "1",
      border: "1px solid",
      borderColor: "border.secondary",
      borderRadius: "radius-md",
      overflow: "hidden",
      direction: "column",
      children: [
        /* @__PURE__ */ m(
          C,
          {
            height: n ? "auto" : "3rem",
            color: "foreground.primary",
            w: "100%",
            bg: i ? "background.accent-primary.light" : "background.secondary",
            children: [
              n && s && /* @__PURE__ */ r(R1, { src: n, objectFit: "cover", h: "11rem", w: "100%" }),
              n && !s && n
            ]
          }
        ),
        /* @__PURE__ */ m(C, { backgroundColor: "background.primary", direction: "row", p: "1rem", gap: "0.5rem", w: "100%", children: [
          /* @__PURE__ */ m(C, { direction: "column", children: [
            /* @__PURE__ */ r(f, { mb: "spacing-xs", noOfLines: 2, textStyle: "label/M/regular", children: t }),
            /* @__PURE__ */ r(f, { noOfLines: 3, textStyle: "label/S/regular", color: "foreground.secondary", children: o })
          ] }),
          c && /* @__PURE__ */ r(h, { name: c, ml: "auto" })
        ] })
      ]
    }
  );
}, Qe = me({
  "0%": { opacity: 0 },
  "25%": { opacity: 0 },
  "100%": { opacity: 1 }
}), oe = (e) => {
  const { message: t } = e;
  return t ? /* @__PURE__ */ r(
    H1,
    {
      px: "spacing-md",
      status: "error",
      mt: "spacing-xs",
      overflow: "hidden",
      borderRadius: "radius-sm",
      onClick: (o) => {
        o.stopPropagation();
      },
      children: /* @__PURE__ */ r(z1, { children: /* @__PURE__ */ r(f, { textStyle: "label/S/regular", overflowWrap: "normal", children: t }) })
    }
  ) : null;
}, qr = me`
  0%   { box-shadow: 0 0 0 0 var(--chakra-colors-border-accents-blue-light); }
  70%  { box-shadow: 0 0 0 6px transparent; }
  100% { box-shadow: 0 0 0 0 transparent; }
`, Kr = ({ status: e, size: t = "8px", ...o }) => {
  const n = {
    w: t,
    h: t,
    rounded: "full",
    display: "inline-block"
  }, i = {
    active: {
      bg: "border.accents.blue-dark",
      animation: `${qr} 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite`
    },
    pending: {
      border: "2px solid",
      bg: "background.primary",
      borderColor: "border.accents.blue-dark"
    },
    completed: {
      bg: "border.secondary"
    }
  };
  return /* @__PURE__ */ r(w, { sx: { ...n, ...i[e] }, ...o });
}, Jr = (e) => {
  const {
    title: t,
    status: o = "completed",
    children: n,
    size: i,
    secondary: a,
    noPadding: l,
    HeaderAction: c = null,
    isFirstChild: s,
    isLastChild: g
  } = e;
  return /* @__PURE__ */ r(v, { width: "100%", children: /* @__PURE__ */ m(C, { gap: "spacing-xs", width: "100%", children: [
    /* @__PURE__ */ m(C, { position: "relative", children: [
      /* @__PURE__ */ r(Kr, { mt: "spacing-xs", ml: "spacing-xxs", status: o, zIndex: "10" }),
      !g && /* @__PURE__ */ r(
        C,
        {
          mt: s ? "spacing-xs" : "0",
          position: "absolute",
          insetBlock: 0,
          borderInlineStartWidth: "1px",
          insetInlineStart: "7px"
        }
      )
    ] }),
    /* @__PURE__ */ m(w, { pb: "spacing-xl", width: "100%", children: [
      /* @__PURE__ */ r(
        w,
        {
          as: "span",
          flex: "1",
          textAlign: "left",
          mt: "1px",
          textStyle: i === "sm" ? "label/S/normal" : "label/M/normal",
          color: a ? "text.secondary" : "text.primary",
          whiteSpace: "pre-wrap",
          children: t.trim()
        }
      ),
      c && /* @__PURE__ */ r(Z, {}),
      c,
      n && /* @__PURE__ */ r(C, { pl: "3.5rem", paddingTop: "0", paddingX: l ? "0" : "2", direction: "column", children: n })
    ] })
  ] }) });
}, ie = (e) => {
  const { getAccordionItemProps: t } = D1(), { title: o, children: n, idx: i, size: a, secondary: l, isRunning: c, canHide: s = !0, HeaderAction: g = null } = e, { isOpen: p } = t(i);
  return s ? /* @__PURE__ */ m(
    Ve,
    {
      animation: c ? `${Qe} 0.3s linear` : void 0,
      width: "100%",
      borderTop: "0",
      borderBottom: "0",
      children: [
        /* @__PURE__ */ m(
          Ze,
          {
            as: "div",
            cursor: "pointer",
            gap: "1",
            display: "flex",
            paddingLeft: "0",
            paddingTop: "spacing-sm",
            paddingBottom: "spacing-xs",
            _hover: {
              background: "background.primary"
            },
            children: [
              /* @__PURE__ */ r(w, { transition: "transform 0.2s", transform: p ? "rotate(90deg)" : "rotate(0deg)", children: /* @__PURE__ */ r(h, { size: a === "sm" ? "xs" : "sm", name: "arrow-right-3" }) }),
              /* @__PURE__ */ r(
                w,
                {
                  as: "span",
                  flex: "1",
                  textAlign: "left",
                  textStyle: a === "sm" ? "label/S/medium" : "label/M/medium",
                  color: l ? "text.secondary" : "text.primary",
                  whiteSpace: "pre-wrap",
                  children: o
                }
              ),
              p && g && /* @__PURE__ */ r(Z, {}),
              p && g
            ]
          }
        ),
        /* @__PURE__ */ r(We, { width: "100%", maxWidth: "100%", padding: 0, children: n })
      ]
    }
  ) : /* @__PURE__ */ r(C, { borderBottom: "1px solid", borderColor: "border.secondary", paddingY: "spacing-md", paddingX: "spacing-md", children: /* @__PURE__ */ r(v, { flex: "1", width: "100%", children: n }) });
}, Qr = {
  idle: "pending",
  pending: "pending",
  running: "active",
  success: "completed",
  error: "completed"
}, On = (e) => {
  const { steps: t, onSelectResult: o } = e, n = ee(null);
  return H(() => {
    var i;
    (i = n.current) == null || i.scrollIntoView({ behavior: "auto" });
  }, [t.length]), t.length ? /* @__PURE__ */ m(C, { direction: "column", width: "100%", maxWidth: "100%", height: "100%", children: [
    t.map((i, a) => /* @__PURE__ */ r(w, { animation: i.status === "running" ? `${Qe} 0.3s linear` : void 0, children: /* @__PURE__ */ m(
      Jr,
      {
        idx: a,
        status: Qr[i.status],
        title: i.description,
        createdAt: i.createdAt,
        completedAt: i.completedAt,
        isLastChild: a === t.length - 1,
        isFirstChild: a === 0,
        children: [
          i.dataSources.length > 0 && /* @__PURE__ */ r(X, { allowMultiple: !0, width: "100%", defaultIndex: [0], children: /* @__PURE__ */ r(ie, { idx: 0, title: "Sources", secondary: !0, size: "sm", children: /* @__PURE__ */ r(de, { width: "100%", children: i.dataSources.map((l, c) => /* @__PURE__ */ r(Ee, { ...l }, c)) }) }) }),
          i.codeBlocks.length > 0 && /* @__PURE__ */ m(X, { allowMultiple: !0, width: "100%", defaultIndex: [0], children: [
            i.codeBlocks.map((l, c) => /* @__PURE__ */ m(
              ie,
              {
                isRunning: i.status === "running",
                idx: c,
                title: l.name,
                secondary: !0,
                size: "sm",
                children: [
                  /* @__PURE__ */ r(
                    w,
                    {
                      height: "240px",
                      borderRadius: "radius-md",
                      overflow: "hidden",
                      border: "1px solid",
                      borderColor: "border.secondary",
                      width: "100%",
                      children: /* @__PURE__ */ r(
                        vr,
                        {
                          isEditable: !1,
                          language: l.language,
                          defaultCode: l.code
                        },
                        l.code
                      )
                    }
                  ),
                  l.error && /* @__PURE__ */ r(oe, { message: l.error })
                ]
              },
              c
            )),
            i.errorMessage && /* @__PURE__ */ r(oe, { message: i.errorMessage })
          ] }),
          i.errorMessage && /* @__PURE__ */ r(oe, { message: i.errorMessage }),
          i.result && /* @__PURE__ */ r(X, { allowMultiple: !0, width: "100%", defaultIndex: [0], children: /* @__PURE__ */ r(ie, { idx: 0, title: "Result", secondary: !0, size: "sm", children: /* @__PURE__ */ r(de, { width: "100%", children: /* @__PURE__ */ r(
            Ee,
            {
              resource: {
                createdAt: i.result.createdAt,
                resourceId: i.result.resultId,
                name: i.result.resultName,
                resourceType: i.result.resultType
              },
              onSelect: () => {
                i.result && o(i.result.resultId);
              }
            }
          ) }) }) })
        ]
      }
    ) }, a)),
    /* @__PURE__ */ r(w, { ref: n })
  ] }) : null;
}, Vn = (e) => {
  const {
    maxWidth: t = window.innerWidth,
    maxHeight: o = window.innerHeight,
    minWidth: n = 350,
    minHeight: i = 200,
    width: a = 600,
    height: l = 400
  } = e;
  return /* @__PURE__ */ r(
    Ne,
    {
      resizeHandles: ["se"],
      axis: "both",
      width: a,
      height: l,
      style: { overflow: "hidden", border: "none", borderRadius: "0px" },
      minConstraints: [n, i],
      maxConstraints: [t, o],
      children: /* @__PURE__ */ r(
        C,
        {
          borderRadius: "radius-md",
          overflow: "hidden",
          flexDirection: "column",
          height: "100%",
          width: "100%",
          border: "1px",
          borderColor: "border.secondary",
          children: e.children
        }
      )
    }
  );
}, L = {
  text: {
    primary: {
      light: _[800],
      dark: _[200]
    },
    secondary: {
      light: _[600],
      dark: _[500]
    }
  },
  grid: {
    light: _[400],
    dark: _[800]
  },
  axis: {
    light: _[300],
    dark: _[700]
  },
  categorical: {
    1: {
      light: z[300],
      dark: z[300]
    },
    2: {
      light: $[500],
      dark: $[500]
    },
    3: {
      light: T[700],
      dark: T[700]
    },
    4: {
      light: B[500],
      dark: B[600]
    },
    5: {
      light: D[500],
      dark: D[500]
    },
    6: {
      light: j[800],
      dark: G[500]
    },
    7: {
      light: B[200],
      dark: j[700]
    },
    8: {
      light: z[600],
      dark: B[300]
    },
    9: {
      light: D[200],
      dark: z[600]
    },
    10: {
      light: $[800],
      dark: G[200]
    },
    11: {
      light: T[300],
      dark: T[500]
    },
    12: {
      light: j[400],
      dark: D[200]
    }
  }
}, e0 = (e) => (e.encoding && Object.keys(e.encoding).forEach((t) => {
  const o = e.encoding[t];
  o && typeof o == "object" && o.type === "nominal" && (o.axis ? typeof o.axis == "object" && (o.axis = { labelAngle: 30, labelLimit: 60, ...o.axis }) : o.axis = { labelAngle: 30, labelLimit: 60 });
}), e), ae = 0, U = 0.75, t0 = (e, t) => {
  var n;
  let o = t || ((n = e.title) == null ? void 0 : n.text) || e.title;
  return o && (e.title = {
    text: o
  }), e;
}, r0 = (e) => (e.encoding && e.encoding.column && (e.encoding.xOffset = {
  field: e.encoding.column.field,
  type: e.encoding.column.type
}, delete e.encoding.column), e), n0 = (e, t) => {
  var o;
  return ((o = e == null ? void 0 : e.mark) == null ? void 0 : o.type) === "text" && (e.mark.color = L.text.primary[t]), e;
}, o0 = (e) => {
  var t;
  return ((t = e == null ? void 0 : e.mark) == null ? void 0 : t.type) === "text" && e.encoding.y && (e.transform = [
    {
      calculate: `datum['${e.encoding.y.field}'] < 0 ? 8 : -8`,
      as: "text_padding_y"
    }
  ], e.mark.dy = { expr: "datum.text_padding_y" }), e;
}, i0 = (e, t) => {
  var o, n;
  return t && typeof t == "object" && "values" in t && e.encoding && !((o = e.encoding) != null && o.text) && Array.isArray(t.values) && t.values.length === 1 && (e = {
    layer: [
      {
        mark: {
          type: "text"
        },
        encoding: {
          text: { field: (n = e.encoding.y) == null ? void 0 : n.field, type: "quantitative" }
        }
      },
      {
        mark: {
          type: "text",
          align: "center",
          dy: 80,
          fontSize: 24
        },
        encoding: {
          text: { field: e.encoding.x.field, type: "nominal" }
        }
      }
    ]
  }), e;
}, a0 = (e, t) => {
  var o;
  return t && typeof t == "object" && "values" in t && ((o = e.encoding) != null && o.text) && e.encoding.text.type == "quantitative" && Array.isArray(t.values) && t.values.length === 1 && typeof e.mark == "object" && (e.mark.align = "center", e.mark.fontWeight = "bold", e.mark.fontSize = 54), e;
}, l0 = (e, t) => {
  if (e.encoding && e.encoding.color) {
    const o = e.encoding.color;
    typeof o == "object" && o.type === "nominal" && (e.encoding.color = {
      ...o,
      scale: { range: t }
    });
  }
  return e;
}, d0 = (e) => {
  if (e.encoding && !e.encoding.tooltip) {
    const t = [];
    Object.keys(e.encoding).forEach((o) => {
      if (o !== "tooltip") {
        const n = e.encoding[o];
        if (n && typeof n == "object" && n.field && n.type) {
          const i = { field: n.field, type: n.type };
          n.aggregate && (i.aggregate = n.aggregate), n.type === "temporal" && (i.format = "%Y-%m-%d"), n.type === "quantitative" && (i.format = ".2f"), t.push(i);
        }
      }
    }), t.length > 0 && (e.encoding.tooltip = t);
  }
  return e;
}, s0 = (e) => (e.hconcat ? (e.hconcat.forEach((t) => {
  e.layer.push(t);
}), delete e.hconcat) : e.vconcat && (e.vconcat.forEach((t) => {
  e.layer.push(t);
}), delete e.vconcat), delete e.resolve, e), c0 = (e) => (e.layer || (e.layer = []), e.encoding ? (e.layer.push({ encoding: e.encoding, mark: e.mark }), delete e.encoding, delete e.mark) : (e.hconcat || e.vconcat) && (e = s0(e)), e), g0 = (e) => (e.encoding && e.encoding.x && (e.encoding.x.axis || (e.encoding.x.axis = {}), e.encoding.x.axis.tickCount = 10), e), e1 = (e) => {
  var t;
  return e.mark === "bar" || ((t = e.mark) == null ? void 0 : t.type) === "bar";
}, Le = (e) => (e1(e) && (typeof e.mark == "string" ? e.mark = { type: e.mark, cornerRadiusEnd: ae, width: { band: U } } : e.mark ? (e.mark.cornerRadiusEnd = ae, e.mark.width ? e.mark.width.band = U : e.mark.width = { band: U }) : e.mark = { type: "bar", cornerRadiusEnd: ae, width: { band: U } }), e), m0 = (e, t) => {
  const o = L.categorical[1][t];
  return structuredClone(e).layer.forEach((i, a) => {
    var g, p, u, b;
    if (i.layer || !(e1(i) && i.encoding)) return;
    const l = { layer: [] }, c = `hover-${a}`, s = {
      params: [
        {
          name: c,
          select: { type: "point", on: "mouseover", clear: "mouse out" }
        }
      ],
      mark: {
        type: "bar",
        color: o,
        orient: "vertical"
      },
      encoding: {
        x: { ...i.encoding.x, sort: null },
        tooltip: [
          { field: i.encoding.x.field, type: i.encoding.x.type },
          { field: (g = i.encoding.y) == null ? void 0 : g.field, type: (p = i.encoding.y) == null ? void 0 : p.type }
        ],
        opacity: {
          condition: { test: { param: c, empty: !1 }, value: 0.2 },
          value: 0
        }
      }
    };
    if (!i.encoding.color) {
      delete i.encoding.tooltip;
      const k = ((u = i.mark) == null ? void 0 : u.orient) === "horizontal" ? "x" : "y";
      i.encoding[k].type === "quantitative" && (i.encoding[k].aggregate = "sum");
    }
    ((b = i.mark) == null ? void 0 : b.orient) == "horizontal" && (delete s.encoding.x, s.encoding.y = { ...i.encoding.y, sort: null }, s.mark.orient = "horizontal"), Le(i), Le(s), l.layer.push(s), l.layer.push(i), e.layer.splice(a + 1, 0, l), e.layer.splice(a, 1);
  }), e;
}, p0 = (e) => (e.layer.map((t, o) => {
  if (t.encoding && t.encoding.color && t.encoding.color.field) {
    const n = `legend-highlight-${o}`;
    return t.params = [
      {
        name: n,
        select: { type: "point", fields: [t.encoding.color.field] },
        bind: "legend"
      }
    ], t.encoding.opacity = {
      condition: { param: n, value: 1 },
      value: 0.2
    }, t;
  }
}), e), u0 = (e, t) => (structuredClone(e).layer.forEach((n, i) => {
  var a, l, c;
  if (!n.layer && (n.mark == "line" || ((a = n.mark) == null ? void 0 : a.type) == "line")) {
    const s = { layer: [] }, g = `ts-label-${i}`;
    s.layer.push(n);
    const p = {
      encoding: {
        x: n.encoding.x,
        y: n.encoding.y,
        color: n.encoding.color
      },
      transform: [{ filter: { param: g, empty: !1 } }],
      mark: { type: "point", filled: !0 }
    };
    s.layer.push(p);
    let u = [
      {
        field: n.encoding.x.field,
        type: n.encoding.x.type,
        format: n.encoding.x.type === "temporal" ? "%Y-%m-%d" : void 0
      }
    ];
    if (e.transform && Array.isArray(e.transform)) {
      const y = e.transform.find((k) => k.fold);
      y && Array.isArray(y.fold) && (u = u.concat(
        y.fold.map((k) => ({
          field: k,
          type: "quantitative",
          format: ".2f"
        }))
      ));
    }
    const b = {
      mark: { type: "rule", strokeDash: [3, 3] },
      encoding: {
        x: n.encoding.x,
        color: { value: L.text.secondary[t] },
        opacity: {
          condition: { value: 0.3, param: g, empty: !1 },
          value: 0
        }
      },
      params: [
        {
          name: g,
          select: {
            type: "point",
            fields: [n.encoding.x.field],
            nearest: !0,
            on: "pointerover",
            clear: "pointerout"
          }
        }
      ]
    };
    n.encoding.color ? (b.mark = {
      type: "rule",
      tooltip: { content: "data" }
    }, b.transform = [
      {
        pivot: n.encoding.color.field,
        value: n.encoding.y.field,
        groupby: [n.encoding.x.field]
      }
    ]) : (u.length === 1 && ((c = (l = n.encoding) == null ? void 0 : l.y) != null && c.field) && u.push({
      field: n.encoding.y.field,
      type: n.encoding.y.type || "quantitative",
      format: ".2f"
    }), b.encoding.tooltip = u), s.layer.push(b), delete s.layer[0].encoding.tooltip, s.layer[0].mark && delete s.layer[0].mark.point, e.layer.splice(i + 1, 0, s), e.layer.splice(i, 1);
  }
}), e), C0 = (e) => (e.encoding && Object.values(e.encoding).forEach((t) => {
  (t == null ? void 0 : t.legend) === null && delete t.legend;
}), e), h0 = (e) => (structuredClone(e).layer.forEach((o, n) => {
  o.encoding || e.layer.splice(n, 1);
}), e), f0 = (e, t) => {
  if (!e.encoding) return e;
  const o = t && typeof t == "object" && Array.isArray(t.values) ? t.values : null, n = (i) => !i || !o ? !0 : o.some((a) => {
    const l = a[i];
    return typeof l == "number" && Math.abs(l) >= 1e3;
  });
  return ["x", "y"].forEach((i) => {
    const a = e.encoding[i];
    a && typeof a == "object" && a.type === "quantitative" && n(a.field) && (a.axis || (a.axis = {}), a.axis.format = "~s");
  }), e;
}, t1 = (e) => {
  var t;
  return e.layer && Array.isArray(e.layer) && (e.layer = e.layer.map((o) => t1(o))), e.mark === "line" ? e.mark = { type: "line", interpolate: "monotone" } : ((t = e.mark) == null ? void 0 : t.type) === "line" && (e.mark.interpolate = "monotone"), e;
}, b0 = (e, t, o, n, i) => (e = structuredClone(e), e = t0(e, o), e = i0(e, n), e = c0(e), e = h0(e), e = p0(e), e.layer.map((a) => (a = a0(a, n), a = n0(a, i), a = o0(a), a = g0(a), a = f0(a, n), a = l0(a, t), a = d0(a), a = r0(a), a = e0(a), a = C0(a), a)), e = m0(e, i), e = u0(e, i), e = t1(e), e);
function W(e, t, o) {
  return e.fields = t || [], e.fname = o, e;
}
function y0(e) {
  return e.length === 1 ? x0(e[0]) : k0(e);
}
const x0 = (e) => function(t) {
  return t[e];
}, k0 = (e) => {
  const t = e.length;
  return function(o) {
    for (let n = 0; n < t; ++n)
      o = o[e[n]];
    return o;
  };
};
function le(e) {
  throw Error(e);
}
function w0(e) {
  const t = [], o = e.length;
  let n = null, i = 0, a = "", l, c, s;
  e = e + "";
  function g() {
    t.push(a + e.substring(l, c)), a = "", l = c + 1;
  }
  for (l = c = 0; c < o; ++c)
    if (s = e[c], s === "\\")
      a += e.substring(l, c++), l = c;
    else if (s === n)
      g(), n = null, i = -1;
    else {
      if (n)
        continue;
      l === i && s === '"' || l === i && s === "'" ? (l = c + 1, n = s) : s === "." && !i ? c > l ? g() : l = c + 1 : s === "[" ? (c > l && g(), i = l = c + 1) : s === "]" && (i || le("Access path missing open bracket: " + e), i > 0 && g(), i = 0, l = c + 1);
    }
  return i && le("Access path missing closing bracket: " + e), n && le("Access path missing closing quote: " + e), c > l && (c++, g()), t;
}
function S0(e, t, o) {
  const n = w0(e);
  return e = n.length === 1 ? n[0] : e, W(y0(n), [e], e);
}
S0("id");
W((e) => e, [], "identity");
W(() => 0, [], "zero");
W(() => 1, [], "one");
W(() => !0, [], "true");
W(() => !1, [], "false");
var v0 = Array.isArray;
function _e(e) {
  return e === Object(e);
}
function E0(e) {
  return typeof e == "string";
}
function L0(e, t, o, n) {
  if (v0(e))
    return `[${e.map((i) => t(E0(i) ? i : Fe(i, o))).join(", ")}]`;
  if (_e(e)) {
    let i = "";
    const { title: a, image: l, ...c } = e;
    a && (i += `<h2>${t(a)}</h2>`), l && (i += `<img src="${new URL(t(l), n || location.href).href}">`);
    const s = Object.keys(c);
    if (s.length > 0) {
      i += "<table>";
      for (const g of s) {
        let p = c[g];
        p !== void 0 && (_e(p) && (p = Fe(p, o)), i += `<tr><td class="key">${t(g)}</td><td class="value">${t(p)}</td></tr>`);
      }
      i += "</table>";
    }
    return i || "{}";
  }
  return t(e);
}
function _0(e) {
  const t = [];
  return function(o, n) {
    if (typeof n != "object" || n === null)
      return n;
    const i = t.indexOf(this) + 1;
    return t.length = i, t.length > e ? "[Object]" : t.indexOf(n) >= 0 ? "[Circular]" : (t.push(n), n);
  };
}
function Fe(e, t) {
  return JSON.stringify(e, _0(t));
}
var F0 = `#vg-tooltip-element {
  visibility: hidden;
  padding: 8px;
  position: fixed;
  z-index: 1000;
  font-family: sans-serif;
  font-size: 11px;
  border-radius: 3px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  /* The default theme is the light theme. */
  background-color: rgba(255, 255, 255, 0.95);
  border: 1px solid #d9d9d9;
  color: black;
}
#vg-tooltip-element.visible {
  visibility: visible;
}
#vg-tooltip-element h2 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 13px;
}
#vg-tooltip-element table {
  border-spacing: 0;
}
#vg-tooltip-element table tr {
  border: none;
}
#vg-tooltip-element table tr td {
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 2px;
  padding-bottom: 2px;
}
#vg-tooltip-element table tr td.key {
  color: #808080;
  max-width: 150px;
  text-align: right;
  padding-right: 4px;
}
#vg-tooltip-element table tr td.value {
  display: block;
  max-width: 300px;
  max-height: 7em;
  text-align: left;
}
#vg-tooltip-element.dark-theme {
  background-color: rgba(32, 32, 32, 0.9);
  border: 1px solid #f5f5f5;
  color: white;
}
#vg-tooltip-element.dark-theme td.key {
  color: #bfbfbf;
}
`;
const r1 = "vg-tooltip-element", M0 = {
  offsetX: 10,
  offsetY: 10,
  id: r1,
  styleId: "vega-tooltip-style",
  theme: "light",
  disableDefaultStyle: !1,
  sanitize: A0,
  maxDepth: 2,
  formatTooltip: L0,
  baseURL: "",
  anchor: "cursor",
  position: ["top", "bottom", "left", "right", "top-left", "top-right", "bottom-left", "bottom-right"]
};
function A0(e) {
  return String(e).replace(/&/g, "&amp;").replace(/</g, "&lt;");
}
function I0(e) {
  if (!/^[A-Za-z]+[-:.\w]*$/.test(e))
    throw new Error("Invalid HTML ID");
  return F0.toString().replace(r1, e);
}
function n1(e, t, { offsetX: o, offsetY: n }) {
  const i = o1({ x1: e.clientX, x2: e.clientX, y1: e.clientY, y2: e.clientY }, t, o, n), a = ["bottom-right", "bottom-left", "top-right", "top-left"];
  for (const l of a)
    if (i1(i[l], t))
      return i[l];
  return i["top-left"];
}
function R0(e, t, o, n, i) {
  const { position: a, offsetX: l, offsetY: c } = i, s = e._el.getBoundingClientRect(), g = e._origin, p = H0(s, g, o), u = o1(p, n, l, c), b = Array.isArray(a) ? a : [a];
  for (const y of b)
    if (i1(u[y], n) && !z0(t, u[y], n))
      return u[y];
  return n1(t, n, i);
}
function H0(e, t, o) {
  const n = o.isVoronoi ? o.datum.bounds : o.bounds;
  let i = e.left + t[0] + n.x1, a = e.top + t[1] + n.y1, l = o;
  for (; l.mark.group; )
    l = l.mark.group, i += l.x ?? 0, a += l.y ?? 0;
  const c = n.x2 - n.x1, s = n.y2 - n.y1;
  return {
    x1: i,
    x2: i + c,
    y1: a,
    y2: a + s
  };
}
function o1(e, t, o, n) {
  const i = (e.x1 + e.x2) / 2, a = (e.y1 + e.y2) / 2, l = e.x1 - t.width - o, c = i - t.width / 2, s = e.x2 + o, g = e.y1 - t.height - n, p = a - t.height / 2, u = e.y2 + n;
  return {
    top: { x: c, y: g },
    bottom: { x: c, y: u },
    left: { x: l, y: p },
    right: { x: s, y: p },
    "top-left": { x: l, y: g },
    "top-right": { x: s, y: g },
    "bottom-left": { x: l, y: u },
    "bottom-right": { x: s, y: u }
  };
}
function i1(e, t) {
  return e.x >= 0 && e.y >= 0 && e.x + t.width <= window.innerWidth && e.y + t.height <= window.innerHeight;
}
function z0(e, t, o) {
  return e.clientX >= t.x && e.clientX <= t.x + o.width && e.clientY >= t.y && e.clientY <= t.y + o.height;
}
class D0 {
  /**
   * Create the tooltip handler and initialize the element and style.
   *
   * @param options Tooltip Options
   */
  constructor(t) {
    this.options = { ...M0, ...t };
    const o = this.options.id;
    if (this.el = null, this.call = this.tooltipHandler.bind(this), !this.options.disableDefaultStyle && !document.getElementById(this.options.styleId)) {
      const n = document.createElement("style");
      n.setAttribute("id", this.options.styleId), n.innerHTML = I0(o);
      const i = document.head;
      i.childNodes.length > 0 ? i.insertBefore(n, i.childNodes[0]) : i.appendChild(n);
    }
  }
  /**
   * The tooltip handler function.
   */
  tooltipHandler(t, o, n, i) {
    if (this.el = document.getElementById(this.options.id), this.el || (this.el = document.createElement("div"), this.el.setAttribute("id", this.options.id), this.el.classList.add("vg-tooltip"), (document.fullscreenElement ?? document.body).appendChild(this.el)), i == null || i === "") {
      this.el.classList.remove("visible", `${this.options.theme}-theme`);
      return;
    }
    this.el.innerHTML = this.options.formatTooltip(i, this.options.sanitize, this.options.maxDepth, this.options.baseURL), this.el.classList.add("visible", `${this.options.theme}-theme`);
    const { x: a, y: l } = this.options.anchor === "mark" ? R0(t, o, n, this.el.getBoundingClientRect(), this.options) : n1(o, this.el.getBoundingClientRect(), this.options);
    this.el.style.top = `${l}px`, this.el.style.left = `${a}px`;
  }
}
const B0 = (e) => String(e).replace(/&/g, "&amp;").replace(/</g, "&lt;"), T0 = (e) => (t, o = B0, n, i) => {
  if (typeof t == "object" && t !== null) {
    const a = Object.entries(t);
    let l = "<table>";
    return a.forEach(([c, s], g) => {
      const p = g > 0 ? e[(g - 1) % e.length] : null, u = p ? `<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${p};margin-right:4px"></span>` : "";
      l += `<tr><td class="key">${u}${o(c)}</td><td class="value">${o(s)}</td></tr>`;
    }), l += "</table>", l;
  }
  return o(t);
}, pe = () => {
  const { colorMode: e } = Q();
  return Object.values(L.categorical).map((t) => t[e]);
}, P0 = () => {
  const { colorMode: e } = Q(), t = pe();
  return new D0({
    theme: e,
    formatTooltip: T0(t)
  }).call;
}, O0 = () => {
  const { colorMode: e } = Q();
  return {
    background: "transparent",
    range: {
      category: pe()
    },
    title: {
      font: "Inter, sans-serif",
      fontWeight: 500,
      color: L.text.primary[e],
      fontSize: 16,
      anchor: "start",
      offset: 24
    },
    axis: {
      labelColor: L.text.secondary[e],
      labelFontSize: 12,
      titlePadding: 12,
      titleFontWeight: "normal",
      titleColor: L.text.primary[e],
      domainColor: L.axis[e],
      domainOpacity: 1,
      ticks: !1,
      gridColor: L.grid[e],
      gridDash: [3, 3],
      gridOpacity: 0.6
    },
    axisLeft: {
      labelAlign: "left",
      labelOffset: -12,
      domainOpacity: 0,
      ticks: !0,
      tickSize: 48,
      tickDash: [3, 3],
      tickOpacity: 0.6,
      tickColor: L.grid[e]
    },
    axisBottom: {
      labelPadding: 8
    },
    legend: {
      // TODO: only apply to color encodings
      // orient: "top",
      // title: null,
      titleColor: L.text.primary[e],
      titleFontWeight: "normal",
      labelColor: L.text.secondary[e]
    },
    view: {
      stroke: "transparent"
    }
  };
}, Me = 28, V0 = (e, t, o, n) => {
  const i = pe(), { colorMode: a } = Q(), [l, c] = S({ width: 0, height: 0 });
  return H(() => {
    const p = () => {
      if (n.current) {
        const { width: u, height: b } = n.current.getBoundingClientRect();
        c({ width: u, height: b });
      }
    };
    if (n.current) {
      p();
      const u = new ResizeObserver(() => p());
      return u.observe(n.current), () => {
        u.disconnect();
      };
    }
  }, [n]), {
    ...b0(o, i, e, t, a),
    $schema: "https://vega.github.io/schema/vega-lite/v5.json",
    data: t,
    width: l.width - Me,
    autosize: {
      type: "fit",
      contains: "padding"
    },
    height: l.height - Me
  };
}, Zn = (e) => {
  const { title: t, data: o, spec: n } = e, i = ee(null), a = O0(), l = V0(t, o, n, i), c = P0();
  return /* @__PURE__ */ r(w, { ref: i, height: "100%", width: "100%", padding: "spacing-md", children: /* @__PURE__ */ r(it, { spec: l, actions: !1, config: a, tooltip: c }) });
}, Wn = me`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  `;
function $n(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const jn = (e) => {
  const t = at(e);
  return lt(t, /* @__PURE__ */ new Date()) ? fe(t, "HH:mm MMM dd") : fe(t, "HH:mm MMM dd, yyyy");
}, Z0 = (e, t, o = 0) => {
  const n = /^(.*?)(?: \((\d+)\))?$/, i = e.match(n), a = i == null ? void 0 : i[1];
  let l = o;
  i && i[2] && (l = parseInt(i[2], 10) + o);
  const c = l === 0 ? a : `${a} (${l})`;
  return t.includes(c) ? Z0(a, t, l + 1) : c;
}, W0 = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 0C3.58172 0 0 3.58172 0 8V18C0 22.4183 3.58172 26 8 26H18C22.4183 26 26 22.4183 26 18V8C26 3.58172 22.4183 0 18 0H8ZM13 11C13 12.6569 11.6569 14 10 14C8.34315 14 7 12.6569 7 11C7 9.34315 8.34315 8 10 8C11.6569 8 13 9.34315 13 11ZM15 11C15 13.7614 12.7614 16 10 16C7.23858 16 5 13.7614 5 11C5 8.23858 7.23858 6 10 6C12.7614 6 15 8.23858 15 11Z", fill: "currentColor" })), Nn = W0;
export {
  wr as Banner,
  pn as Breadcrumb,
  vr as CodeEditor,
  Xr as ConnectorIcon,
  Fr as DataTable,
  fn as DeleteConfirmationModal,
  un as EditableName,
  Ke as EmptyState,
  oe as ErrorAlert,
  Cn as FilePreviewOverlay,
  h as Icon,
  hn as LabelButton,
  A as MenuItem,
  An as MissingResourceBadge,
  xn as Page,
  kn as PageContent,
  yn as PageContentHeader,
  Sn as ParamEditor,
  vn as PermissionButton,
  Nn as PromptStudioLogo,
  bn as RenameItemModal,
  Vn as ResizableContainer,
  Mr as ResizableOverlay,
  Ee as ResourceBadge,
  In as SchemaOutline,
  wn as ScrollableContent,
  Rn as SectionHeader,
  Hn as Sidebar,
  zn as SidebarCategoryTitle,
  Dn as SidebarItem,
  En as SimpleReference,
  Bn as TeamMenuItem,
  Tn as TeamSelector,
  Pn as TemplateCard,
  On as Timeline,
  Zn as VisualizationV2,
  $n as capitalize,
  Qe as fadeIn,
  Fn as getFileIconName,
  Ln as getModelPresetIconName,
  _n as getPlaceholderIconName,
  Mn as getRecordIconName,
  Tr as getResourceIconName,
  Pr as getStatusIconName,
  jn as getTimeFormat,
  Z0 as getUniqueName,
  Wn as spin,
  mn as theme
};
//# sourceMappingURL=index.js.map
